<template>
  <div>
    <div class="form-box text-center">
      <h1 v-if="storeInfo.brand_name" style="position: absolute; top: -57px; left: 90px; font-size: 18px;">{{storeInfo.brand_name}} - {{storeInfo.name_short}}</h1>
      <div class="pa-20">
        <h5 class="text-left"><span class="text-red">＊</span>請輸入/選取需批次變更的項目，指定的變更項目會一鍵套用在所有選擇的門市中，並覆蓋門市原有的設定。</h5>
        <h5 class="text-left"><span class="text-red">＊</span>不同分頁設定項目需分次操作。</h5>
        <h5 class="text-left"><span class="text-red">＊</span>無需變更的項目請維持空白，套用變更時，空白項目將維持門市原有的設定。</h5>
        <h5 class="text-left"><span class="text-red">＊</span>若無需變更的項目誤選取到，可按右方的「清空此頁面設定」按鈕清除（不會變更門市原有的設定）。</h5>
      </div>
      <div class="box-body">
        <ul class="nav nav-tabs" style="margin-bottom: 10px;">
          <li role="presentation" :class="{'active': storeMethod == 1}" @click="storeMethod = 1">
            <a>基本資訊</a>
          </li>
          <li role="presentation" :class="{'active': storeMethod == 2}" @click="storeMethod = 2" v-if="getRoleType === 99 || getRoleType === 30">
            <a>細部設定</a>
          </li>
          <li role="presentation" :class="{'active': storeMethod == 3}" @click="storeMethod = 3">
            <a>預訂/訂購時間</a>
          </li>
          <li role="presentation" :class="{'active': storeMethod == 4}" @click="storeMethod = 4" v-if="getRoleType === 99 || getRoleType === 30">
            <a>付款方式</a>
          </li>
          <li role="presentation" :class="{'active': storeMethod == 5}" @click="storeMethod = 5">
            <a>製作/取餐時間</a>
          </li>
          <li role="presentation" :class="{'active': storeMethod == 6}" @click="storeMethod = 6">
            <a>取餐方式/門檻</a>
          </li>
          <li role="presentation" :class="{'active': storeMethod == 7}" @click="storeMethod = 7">
            <a>營業/公休時間</a>
          </li>
          <li role="presentation" :class="{'active': storeMethod == 8}" @click="storeMethod = 8" v-if="getRoleType === 99 || getRoleType === 30 || getRoleType === 10">
            <a>塑膠袋</a>
          </li>
            <!--確認陣列中是否有900數值-->
          <li role="presentation" :class="{'active': storeMethod == 12}" @click="storeMethod = 12" v-if="getRoleType === 99 && getRestricted.indexOf(900) !== -1">
            <a>計費方式設定</a>
          </li>
          <li role="presentation" :class="{'active': storeMethod == 13}" @click="storeMethod = 13" v-if="getRoleType === 99">
            <a>物流設定</a>
          </li>
          <li role="presentation" :class="{'active': storeMethod == 15}" @click="storeMethod = 15" v-if="getRoleType === 99 || getRoleType === 30 || getRoleType === 10">
            <a>特殊需求</a>
          </li>
        </ul>
        <div class="text-right">
          <button class="btn btn-danger" @click="clearPage()">
            清空此頁面設定
          </button>
        </div>
      </div>
      <!-- /.box-header -->

      <!-- 店家資訊 -->
      <div class="box-body form" v-show="storeMethod === 1">
        <h3>店家資訊</h3>

        <!-- 店家公吿設定 -->
        <div v-if="getRoleType === 99 || getRoleType === 30">
          <div class="input-group">
            <span class="input-group-addon">
              店家公吿設定
              <span class="nd-tooltip">
                <ion-icon name="help-circle"></ion-icon>
                <span class="nd-tooltip-text center">
                  選擇"清空現有店家公告"將會<br>清除套用門市的原有公告。
                </span>
              </span>
            </span>
            <div class="form-group">
              <div class="form-group text-left">
                <div class="radio inline-block pt-5">
                  <label>
                    <input type="radio" name="removeComment" :value="false" v-model="removeComment">編輯店家公告
                  </label>
                </div>
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="removeComment" :value="true" v-model="removeComment">清空現有店家公告
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End 店家公吿設定 -->

        <!-- 店家公告 -->
        <div v-if="getRoleType === 99 || getRoleType === 30">
          <div v-if="!removeComment && removeComment != null" class="input-group m-t-25">
            <span class="input-group-addon">
              店家公告
            </span>
            <input class="form-control" placeholder="" type="text" v-model="storeInfo.comment" maxlength="20">
            <br />
          </div>
        </div>
        <!-- End 店家公告 -->

        <!-- 餐點種類 -->
        <div v-if="getRoleType === 99">
          <div class="input-group m-t-5">
            <span class="input-group-addon">
              餐點種類
            </span>
            <div>
              <multiselect
                v-model="storeInfo.binding_meal_tag_ids"
                tag-placeholder="餐點種類"
                placeholder="餐點種類"
                label="label"
                track-by="value"
                :options="mealTagList"
                :multiple="true"
              />
            </div>
          </div>
          <br />
        </div>
        <!-- End 餐點種類 -->
        <br />
        <!-- 描述 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              描述
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.description"
              maxlength="100"
            />
          </div>
          <br />
        </div>
        <!-- End 描述 -->

        <!-- 描述(搜尋引擎顯示) -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              描述(搜尋引擎顯示)
            </span>
            <input
              class="form-control"
              placeholder=""
              type="text"
              v-model="storeInfo.search_description"
              maxlength="100"
            />
          </div>
          <br />
        </div>
        <!-- End 描述(搜尋引擎顯示) -->

        <!-- 品牌頁介紹 -->
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              品牌頁介紹
            </span>
            <textarea
              class="w-100-p form-control"
              name="introduction"
              v-model="storeInfo.introduction"
              cols="30"
              rows="10"
              maxlength="65535"
            />
          </div>
          <br />
        </div>
        <!-- End 品牌頁介紹 -->

        <!-- Youtube 影片代碼 -->
        <div v-if="getRoleType === 99 || getRoleType === 30">
          <div class="input-group m-t-5">
            <span class="input-group-addon">
              Youtube 影片代碼
            </span>
            <div>
              <input class="form-control" placeholder="" type="text" v-model="storeInfo.youtube_video_code" maxlength="50">
            </div>
          </div>
          <br />
        </div>
        <!-- End Youtube 影片代碼 -->

        <!-- 肉品產地說明 -->
        <div v-if="getRoleType === 99 || getRoleType === 30">
          <div class="input-group">
            <span class="input-group-addon">
              肉品產地說明
            </span>
            <textarea
              class="form-control"
              rows="5"
              maxlength="500"
              placeholder="範例：本店牛肉來源－澳洲 / 豬肉來源－台灣"
              v-model="storeInfo.meat_origin_description"
            />
          </div>
          <br />
        </div>
        <!-- End 肉品產地說明 -->

        <div v-if="getRoleType === 99 || getRoleType === 30">
          <div>
            <div class="input-group">
            <span class="input-group-addon">
              LOGO
            </span>
              <div class="input-group-addon w-100-p text-center p-all-0 bg-white" style="border-right: none;">
              <span class="inline-block h-auto m-t-5">
                <div v-if="!storeInfo.image_name" class="text-black" v-text="'沒有圖片'" />
                <img :src="storeInfo.image_name" class="h-auto img-responsive" v-if="storeInfo.image_name" data-toggle="modal">
              </span>
              </div>
              <div class="form-control h-100">
                <div v-if="imgLogoOption.length" class="pull-left">
                  <select class="form-control" v-model="imgLogoSelect">
                    <option :value="img.name" v-for="(img, index) in imgLogoOption">{{img.name}}</option>
                  </select>
                </div>
                <div class="pull-left">
                  <label class="btn-upload btn btn-default" style="margin-top: 8px;" for="brand-img-load" :class="{'m-t-25': !imgLogoOption.length}">
                    選擇圖片
                  </label>
                  <input class="form-control" type="file" style="display: none;" @change="onFileChange" id="brand-img-load">
                </div>
              </div>
            </div>
          </div>
          <div class="text-right text-15 text-red">(圖片大小為200x200)<br /></div>
          <div v-if="getRoleType === 99 || getRoleType === 30">
            <div class="input-group">
              <span class="input-group-addon">
                底圖照片
              </span>
              <div class="input-group-addon w-100-p text-center p-all-0 bg-white" style="border-right: none;">
                <span class="inline-block h-auto m-t-5">
                  <div v-if="!storeInfo.photo_name" class="text-black" v-text="'沒有圖片'" />
                  <img :src="storeInfo.photo_name" class="h-auto img-responsive" v-if="storeInfo.photo_name" data-toggle="modal">
                </span>
              </div>
              <div class="form-control h-100">
                <label class="btn-upload btn btn-default" style="margin-top: 25px;" for="brand-photo-load">
                  選擇圖片
                </label>
                <input class="form-control" type="file" style="display: none;" @change="onPhotoFileChange" id="brand-photo-load">
              </div>
            </div>
          </div>
          <div class="text-right text-15 text-red">(圖片大小為800x460)<br /></div>
        </div>
      </div>
      <!-- End 店家資訊 -->

      <!-- 細部設定 -->
      <div class="box-body form" v-show="storeMethod === 2">
        <div>
          <div><h3>細部設定</h3></div>
          <br />
          <div v-if="reCheckOption.body" class="hint mb-1">
            <i class="fa fa-close re-check-close" @click="invalidStoreMap=null"></i>
            <span v-html="reCheckOption.body"></span>
          </div>
          <div v-if="getRoleType === 99">
            <div class="input-group">
              <span class="input-group-addon">
                API服務類型
              </span>
              <div class="form-group">
                <select class="form-control" v-model="apiTypeSelect">
                  <option value="1">專屬客製POS</option>
                  <option value="2">公版POS</option>
                  <option value="3">平板接單</option>
                </select>
              </div>
            </div>
            <br />
          </div>
          <div v-if="getRoleType === 99">
            <div class="input-group">
              <span class="input-group-addon">
                營業狀態
              </span>
              <div class="form-group">
                <select class="form-control" v-model="statusSelect">
                  <option value="0">尚未營業</option>
                  <option value="1">籌備中</option>
                  <option value="2">營業中(上架)</option>
                  <option value="3">休息中</option>
                  <option value="9">已歇業</option>
                </select>
              </div>
            </div>
            <br />
          </div>
          <div v-if="getRoleType === 99 || getRoleType == 30">
            <div class="input-group">
            <span class="input-group-addon">
              距離計算模式
            </span>
              <div class="form-group">
                <select class="form-control" v-model="disModeSelect">
                  <option value="11">走路模式(WALKING)</option>
                  <option value="12">開車模式(DRIVING)</option>
                  <option value="13">機車(SCOOTER)</option>
                  <option value="14">大眾運輸(TRANSIT)</option>
                </select>
              </div>
            </div>
            <br />
          </div>
          <div v-if="getRoleType === 99">
            <div class="input-group">
          <span class="input-group-addon">
            條碼類型
          </span>
              <div class="form-group">
                <select class="form-control" v-model="barcodeSelect">
                  <option value="0">不支援</option>
                  <option value="1">一維條碼</option>
                  <option value="2">二維條碼(QRcode)</option>
                  <option value="3">一維、二維都支援</option>
                </select>
              </div>
            </div>
            <br />
          </div>
          <div v-if="getRoleType === 99">
            <div class="input-group">
              <span class="input-group-addon">
                金額進位
              </span>
              <div class="form-group">
                <select class="form-control" v-model="roundingTypeSelect">
                  <option value="1">無條件進位</option>
                  <option value="2">無條件捨去</option>
                  <option value="3">四捨五入</option>
                  <option value="99">保留小數點</option>
                </select>
              </div>
            </div>
            <br />
          </div>
          <div v-if="getRoleType === 99">
            <div class="input-group">
              <span class="input-group-addon">
                優惠券形式
              </span>
              <div class="form-group">
                <select class="form-control" v-model="couponFormSelect">
                  <option value="1">依付款方式使用優惠券</option>
                  <option value="2">依虛擬商品使用優惠券</option>
                </select>
              </div>
            </div>
            <br />
          </div>
          <div v-if="getRoleType === 99">
            <div class="input-group">
              <span class="input-group-addon">
                自訂設定顯示方式
              </span>
              <div class="form-group">
                <select class="form-control" v-model="showProdSettingSelect">
                  <option value="0">別名跟描述不顯示</option>
                  <option value="1">別名跟描述都顯示</option>
                  <option value="2">只顯示別名</option>
                  <option value="3">只顯示描述</option>
                </select>
              </div>
            </div>
            <br />
          </div>
          <div v-if="getRoleType === 99 || getRoleType == 30">
            <div class="input-group">
            <span class="input-group-addon b-r">
              開放紙本發票
            </span>
              <div class="form-group text-left">
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="invoicePaperOption" :value="1" v-model="hasInvoicePaperSelect">開放
                  </label>
                </div>
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="invoicePaperOption" :value="0" v-model="hasInvoicePaperSelect">停用
                  </label>
                </div>
              </div>
            </div>
            <br />
          </div>
          <div v-if="getRoleType === 99 || getRoleType == 30">
            <div class="input-group">
              <span class="input-group-addon b-r">
                開放電子載具
              </span>
              <div class="form-group text-left">
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="invoiceCarrierOption" :value="1" v-model="hasInvoiceCarrierSelect">開放 (請確認POS端是否支援此功能)
                  </label>
                </div>
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="invoiceCarrierOption" :value="0" v-model="hasInvoiceCarrierSelect">停用
                  </label>
                </div>
              </div>
            </div>
            <br />
          </div>
          <div v-if="getRoleType === 99 || getRoleType == 30">
            <div class="input-group">
              <span class="input-group-addon">
                發票備註
              </span>
              <textarea
                v-model="invoiceRemark"
                class="w-100-p form-control"
                name="invoiceRemark"
                cols="30"
                rows="3"
                maxlength="100"
              />
            </div>
            <div class="text-right">{{ invoiceRemark ? invoiceRemark.length : 0 }}/100</div>
            <br />
          </div>
          <div v-if="getRoleType === 99">
            <div class="input-group">
            <span class="input-group-addon b-r">
              開放愛心捐贈發票
            </span>
              <div class="form-group text-left">
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="invoiceNpobnaOption" :value="1" v-model="hasInvoiceNpobnaSelect">開放
                  </label>
                </div>
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="invoiceNpobnaOption" :value="0" v-model="hasInvoiceNpobnaSelect">停用
                  </label>
                </div>
              </div>
            </div>
            <br />
          </div>
          <div v-if="getRoleType === 99|| getRoleType == 30">
            <div class="input-group">
            <span class="input-group-addon b-r">
              店家是否開立發票
            </span>
              <div class="form-group text-left">
                <div class="radio inline-block">
                  <label>
                    <input
                      v-model="isInvoiceException"
                      type="radio"
                      name="invoiceException"
                      :value="0"
                      :disabled="allInvoiceClosed"
                    >
                    <span :class="{ 'radio-text--disabled': allInvoiceClosed }">
                      開發票
                    </span>
                  </label>
                </div>
                <div class="radio inline-block">
                  <label>
                    <input
                      v-model="isInvoiceException"
                      type="radio"
                      name="invoiceException"
                      :value="1"
                      :disabled="hasInvoiceSelected"
                    >
                    <span :class="{ 'radio-text--disabled': hasInvoiceSelected }">
                      免開發票
                    </span>
                  </label>
                </div>
              </div>
            </div>
            <br />
          </div>
          <div v-if="getRoleType === 99">
            <div class="input-group">
          <span class="input-group-addon">
            前端顯示此店家
          </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="showOption" value="1" v-model="isVisibleSelect">顯示
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="showOption" value="0" v-model="isVisibleSelect">隱藏
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
          <div v-if="getRoleType === 99">
            <div class="input-group">
              <span class="input-group-addon">
                首頁是否搜尋的到店家
              </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="searchOption" value="1" v-model="isSearchSelect">是
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="searchOption" value="0" v-model="isSearchSelect">否
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>

          <div v-if="getRoleType === 99 || getRoleType == 30">
            <div class="input-group">
            <span class="input-group-addon">
              支援客製餐點貼紙
            </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="stickerOption" :value="1" v-model="isStickerSelect">支援 (請確認POS端是否支援此功能)
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="stickerOption" :value="0" v-model="isStickerSelect">不支援
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
          <!-- 貼紙限制字數 -->
          <div>
            <div class="input-group">
              <span class="input-group-addon">
                <span class="text-red">＊ </span>貼紙限制字數
              </span>
              <input
                class="form-control"
                placeholder="僅可輸入數字，最多10字"
                type="number"
                v-model.number.lazy.trim="storeInfo.custom_sticker_max_length"
                min="1"
                max="10"
              />
            </div>
            <br />
          </div>
          <!-- End 貼紙限制字數 -->
          <div v-if="getRoleType === 99 || getRoleType === 30">
            <div class="input-group">
            <span class="input-group-addon b-r">
              <span>強制阻擋外送門檻</span>
              <span class="nd-tooltip">
                <ion-icon name="help-circle" />
                <span class="nd-tooltip-text">
                  若選擇強制阻擋外送門檻，消費者訂購時必須符合「取餐方式/門檻-消費金額與距離門檻」的設定才可下單。注意 : 無論是否強制阻擋外送門檻，外送訂單均須符合最低金額門檻才可下單。
                </span>
              </span>
            </span>
              <div class="form-group text-left">
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="deliveryStageLimit" :value="1" v-model="storeInfo.delivery_stage_limit_type">不強制
                  </label>
                </div>
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="deliveryStageLimit" :value="2" v-model="storeInfo.delivery_stage_limit_type">強制
                  </label>
                </div>
              </div>
            </div>
            <br />
          </div>
          <div v-if="getRoleType === 99 || getRoleType == 30">
            <div class="input-group">
            <span class="input-group-addon b-r">
              單品備註
            </span>
              <div class="form-group text-left">
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="customRemark" :value="1" v-model="storeInfo.is_support_custom_remark">開啟 (請確認POS端是否支援此功能)
                  </label>
                </div>
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="customRemark" :value="0" v-model="storeInfo.is_support_custom_remark">停用
                  </label>
                </div>
              </div>
            </div>
            <br />
          </div>
          <br />
          <div><h3>門市下訂金額限制</h3></div>
          <br />
          <div v-if="getRoleType === 99 || getRoleType === 30">
            <div class="input-group">
          <span class="input-group-addon">
            單筆訂單最高上限(單位:元)
          </span>
              <input class="form-control" placeholder="" type="text" v-model="storeInfo.one_order_max_money" maxlength="6" @keyup="verityOneOrderMaxMoney" ref="oneOrderMaxMoney">
            </div>
            <br />
          </div>
          <br />
          <div><h3>菜單呈現設定</h3></div>
          <br />
          <div v-if="getRoleType === 99">
            <div class="input-group">
          <span class="input-group-addon">
            菜單版型
          </span>
              <div class="form-group">
                <select class="form-control" v-model="storeInfo.menu_layout_type">
                  <option v-for="layout in menuLayout" :value="layout.value">{{layout.label}}</option>
                </select>
              </div>
            </div>
            <br />
          </div>
          <div v-if="getRoleType === 99 || getRoleType == 30">
            <div class="input-group">
          <span class="input-group-addon">
            飲料溫度顯示(冷 熱 無溫度)
          </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="iconOption" value="0" v-model="showMenuIconSelect">全部顯示
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="iconOption" value="1" v-model="showMenuIconSelect">無溫度顯示冷
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="iconOption" value="2" v-model="showMenuIconSelect">皆顯示無溫度
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
          <div v-if="getRoleType === 99">
            <div class="input-group">
          <span class="input-group-addon">
            菜單產品圖示顯示
          </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="prodIconOption" :value="1" v-model="storeInfo.show_menu_product_icon">顯示
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="prodIconOption" :value="0" v-model="storeInfo.show_menu_product_icon">隱藏
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
          <div v-if="getRoleType === 99 || getRoleType == 30">
            <div class="input-group">
            <span class="input-group-addon">
              菜單選項展開類型
            </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="menuExpandType" :value="1" v-model="storeInfo.menu_expand_type">隱藏
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="menuExpandType" :value="2" v-model="storeInfo.menu_expand_type">展開
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>

          <div v-if="getRoleType === 99 || getRoleType == 30">
            <div class="input-group">
            <span class="input-group-addon">
              菜單當日停賣樣式
            </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="menuStopSaleTodayType" :value="1" v-model="storeInfo.menu_stop_sale_today_type">顯示當日停賣ICON
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="menuStopSaleTodayType" :value="2" v-model="storeInfo.menu_stop_sale_today_type">隱藏當日停賣商品
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>

          <div v-if="getRoleType === 99 || getRoleType == 30">
            <div class="input-group">
            <span class="input-group-addon">
              菜單永久停賣樣式
            </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="menuStopSaleType" :value="1" v-model="storeInfo.menu_stop_sale_type">顯示永久停賣ICON
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="menuStopSaleType" :value="2" v-model="storeInfo.menu_stop_sale_type">隱藏永久停賣商品
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>

          <div>
            <div class="input-group">
              <span class="input-group-addon">
                銷售折扣組合(紅配綠)菜單分類顯示
                <span class="nd-tooltip">
                  <ion-icon name="help-circle" />
                  <span class="nd-tooltip-text">
                    若開啟，菜單分類會再新增「紅區」、「綠區」，提升活動能見度！
                  </span>
                </span>
              </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="menu_ab_block_type" :value="1" v-model="storeInfo.menu_ab_block_type">開啟
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="menu_ab_block_type" :value="0" v-model="storeInfo.menu_ab_block_type">關閉
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
      <!-- End 細部設定 -->

      <!-- 預定/訂購時間 -->
      <div class="box-body form" v-show="storeMethod === 3">
        <div><h3>預訂設定</h3></div>
        <br />
        <div v-if="getRoleType === 99 || getRoleType === 30">
          <div class="input-group">
          <span class="input-group-addon">
            開始預訂(距今日幾天，0為當日)
          </span>
            <input class="form-control" placeholder="" type="text" v-model="storeInfo.order_start_day">
          </div>
          <br />
        </div>
        <div v-if="getRoleType === 99 || getRoleType === 30">
          <div class="input-group">
          <span class="input-group-addon">
            結束預訂(距開始預訂幾天，0為開始預訂日)
          </span>
            <input class="form-control" placeholder="" type="text" v-model="storeInfo.order_tolerance_day">
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
          <span class="input-group-addon">
            自動拒絕預約單時間(單位:分鐘)
          </span>
            <input class="form-control" placeholder="" type="text" v-model="storeInfo.auto_reject_order_reserve_m">
          </div>
          <br />
        </div>
        <br />
        <div><h3>接單/送單設定</h3></div>
        <br />
        <div>
          <div class="input-group">
          <span class="input-group-addon">
            接單狀態
          </span>
            <div class="form-group">
              <div class="form-group text-left">
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="orderOption" value="10" v-model="orderStatusSelect">接單中
                  </label>
                </div>
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="orderOption" value="20" v-model="orderStatusSelect">不接單
                  </label>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              暫停接單理由
            </span>
            <input class="form-control" placeholder="" type="text" v-model="storeInfo.order_status_reason" maxlength="10">
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
          <span class="input-group-addon">
            自動拒單時間(單位:分鐘)
          </span>
            <input class="form-control" placeholder="" type="text" v-model="storeInfo.auto_reject_order_m" maxlength="4" @keyup="verityRejectTime" ref="rejectTime">
          </div>
          <br />
        </div>
        <div v-if="getRoleType === 99 || getRoleType === 30">
          <div class="input-group">
          <span class="input-group-addon">
            當日訂購時間前下單
          </span>
            <div class="form-group">
              <div class="form-group text-left">
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="isPreparingAllow" :value="1" v-model="storeInfo.is_preparing_allow_order">可下單
                  </label>
                </div>
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="isPreparingAllow" :value="0" v-model="storeInfo.is_preparing_allow_order">不可下單
                  </label>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
        <div v-if="getRoleType === 99 || getRoleType === 30">
          <div class="input-group">
          <span class="input-group-addon">
            結束訂購時間後下單
          </span>
            <div class="form-group">
              <div class="form-group text-left">
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="isCloseAllow" :value="1" v-model="storeInfo.is_close_allow_order">可下單
                  </label>
                </div>
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="isCloseAllow" :value="0" v-model="storeInfo.is_close_allow_order">不可下單
                  </label>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
      <!-- End 預定/訂購時間 -->

      <!-- 付款方式 -->
      <div class="box-body form" v-show="storeMethod === 4">
        <div><h3>付款方式</h3></div>
        <br />
        <div>
          <table class="table table-bordered table-striped dataTable">
            <thead class="bg-primary">
            <tr>
              <td>付款類型</td>
              <td v-if="getRoleType === 99">支援與否</td>
              <td v-if="getRoleType !== 10">開啟狀態</td>
              <td>
                備註 (顯示在購物車頁面上，消費者可查看)
                <span class="nd-tooltip">
                  <ion-icon name="help-circle"></ion-icon>
                  <span class="nd-tooltip-text">
                    前台顯示畫面，如下方粉色備註區塊
                    <img src='/static/img/trade_remark_ex.png'>
                  </span>
                </span>
              </td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(tradeType, index) in tradeInfo" :key="index">
              <td>{{tradeType.name}}</td>
              <!-- 支援與否 -->
              <td v-if="getRoleType == 99">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" value="1" v-model="tradeType.is_support" >支援
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>

                      <input
                        type="radio"
                        value="0"
                        v-model="tradeType.is_support"
                        @change="clickClose('tradeType', false, tradeType.is_default, dIndex)">不支援
                    </label>
                  </div>
                </div>
              </td>
              <!-- End 支援與否 -->
              <td v-if="getRoleType !== 10">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" value="1" v-model="tradeType.is_enable" @input="setReload">開啟
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input
                        type="radio"
                        value="0"
                        v-model="tradeType.is_enable"
                        @input="setReload"
                        @change="clickClose('tradeType', false, tradeType.is_default, dIndex)"
                      >關閉
                    </label>
                  </div>
                </div>
              </td>
              <td>
                <textarea v-model="tradeType.remark" class="w-100-p form-control" rows="2" :maxlength="remarkMaxlength"></textarea>
                <div class="text-right">{{ tradeType.remark.length || 0 }}/{{remarkMaxlength}}</div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <br>
        <div>
          <h3>現金付款設定</h3>
        </div>
        <div>
          <table class="table table-bordered table-striped dataTable">
            <thead class="bg-primary">
              <tr>
                <td>取餐方式</td>
                <td>付款順序</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>內用-桌邊掃碼</td>
                <td>
                  <div class="form-group text-left">
                    <div class="radio inline-block">
                      <label>
                        <input
                          v-model="tableNumber.is_cash_pay_after_meal"
                          type="radio"
                          :value="0"
                        />
                        餐前付款
                      </label>
                    </div>
                    <div class="radio inline-block">
                      <label>
                        <input
                          v-model="tableNumber.is_cash_pay_after_meal"
                          type="radio"
                          :value="1"
                        />
                        餐後付款
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <br>
        <div><h3>付款方式與取餐金額</h3></div>
        <div class="text-left">
          <button class="btn btn-success" @click="addExceptionTrade">新增限制</button>
        </div>
        <br />
        <div v-if="exceptionTradeList.length">
          <table class="table table-bordered table-striped dataTable">
            <thead class="bg-primary">
            <tr>
              <td>取餐方式</td>
              <td>付款方式</td>
              <td>起始金額</td>
              <td>結束金額</td>
              <td>描述</td>
              <td></td>
            </tr>
            </thead>
            <tbody>
              <tr v-for="(exceptionTrade, eIndex) in exceptionTradeList">
                <td>
                  <select class="form-control" v-model="exceptionTrade.delivery_type">
                    <option :value="0">全部</option>
                    <option :value="delivery.value" v-for="delivery in deliveryInfo">{{delivery.label}}</option>
                  </select>
                </td>
                <td>
                  <select class="form-control" v-model="exceptionTrade.trade_type">
                    <option :value="trade.value" v-for="trade in tradeList">{{trade.label}}</option>
                  </select>
                </td>
                <td>
                  <input placeholder="" type="text" class="form-control w-90 inline-block" v-model="exceptionTrade.start_money">
                </td>
                <td>
                  <input placeholder="" type="text" class="form-control w-90 inline-block" v-model="exceptionTrade.end_money">
                </td>
                <td>
                  {{exceptionTrade.delivery_type | deliveryName}}
                  <span v-if="exceptionTrade.start_money">
                    {{exceptionTrade.start_money}} 元以上
                  </span>
                  <span v-if="exceptionTrade.start_money && exceptionTrade.end_money">
                    ～
                  </span>
                  <span v-if="exceptionTrade.end_money">
                    {{exceptionTrade.end_money}} 元以下
                  </span>
                  不可用{{ exceptionTrade.trade_type | tradeName }}付款
                </td>
                <td>
                  <button class="btn btn-danger" @click="removeListItem(exceptionTradeList, eIndex)"><i class="fa fa-trash"></i></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- End 付款方式 -->

      <!-- 製作/取餐時間 -->
      <div class="box-body form" v-show="storeMethod === 5">
        <div>
          <h3>製作/取餐時間</h3>
          <div>
            準備時間需設定 3 分鐘以上，取餐時間間隔需設定 10 的倍數
          </div>
        </div>
        <br />
        <h5 class="text-left"><span class="text-red">＊</span> 各列設定為群組功能，需將取餐類型的"準備時間+取餐時間間隔"一併設定後才可進行修改。</h5>
        <div class="table-responsive">
          <table class="table table-bordered table-striped dataTable">
            <thead class="bg-primary">
            <tr>
              <td>取餐類型</td>
              <td>準備時間</td>
              <td>取餐時間間隔</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="takeTime in takeTimeInfo" v-show="!hideDeliveryType.includes(takeTime.take_type)">
              <td>{{takeTime.take_type | deliveryName}}</td>
              <td>
                <input class="form-control w-90 inline-block" placeholder="" type="text" v-model="takeTime.prepare_time_seg" @keypress="returnNum">&nbsp;&nbsp;分鐘
              </td>
              <td>
                <span v-if="takeTime.take_type < 3">不需設定</span>
                <span v-else-if="takeTime.take_type === 21">不需設定</span>
                <div v-else class="flex align-center">
                  <div class="input-group-btn flex w-auto">
                    <button
                      class="btn btn-default w-36px"
                      :disabled="!takeTime.take_time_seg"
                      @click="setTakeTime('minus', takeTime)"
                    >
                      -
                    </button>
                    <input
                      class="form-control w-90 inline-block"
                      placeholder=""
                      type="text"
                      v-model="takeTime.take_time_seg"
                      @keypress="returnNum"
                    >
                    <button
                      class="btn btn-default w-36px"
                      @click="setTakeTime('add', takeTime)"
                    >
                      +
                    </button>
                  </div>
                  <div class="m-l-5">分鐘</div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-if="getRoleType === 99 || getRoleType == 30" class="text-left">
          <br>
          <button class="btn btn-success" @click="addProcessTime">新增某時段的製作時間</button>
        </div>
        <div class="m-t-10 process-time-block" v-for="(process, pIndex) in processTimeList">
          <div class="text-right m-b-10"><button class="btn btn-danger" @click="removeListItem(processTimeList, pIndex)"><i class="fa fa-trash"></i></button></div>
          <div>
            <div class="input-group">
            <span class="input-group-addon">
              月份
            </span>
              <div>
                <multiselect v-model="process.month"
                            placeholder="新增月份" label="label" track-by="value" :options="offdaySetting.options.month"
                            :multiple="false" :allow-empty="true"></multiselect>
              </div>
            </div>
            <br />
          </div>
          <div>
            <div class="input-group">
              <span class="input-group-addon">時間類型</span>
              <div class="form-group">
                <select class="form-control" v-model="process.value_type" @change="clearProcess(process)">
                  <option :value="1">日期</option>
                  <option :value="2">星期</option>
                </select>
              </div>
            </div>
            <br>
          </div>
          <div v-if="process.value_type === 2">
            <div class="input-group">
            <span class="input-group-addon">
              開始
            </span>
              <div>
                <multiselect v-model="process.start_value"
                            placeholder="新增星期" label="label" track-by="value" :options="offdaySetting.options.weekDay"
                            :multiple="false" :allow-empty="true"></multiselect>
              </div>
            </div>
            <br />
          </div>
          <div v-if="process.value_type === 1">
            <div class="input-group">
            <span class="input-group-addon">
              開始
            </span>
              <div>
                <multiselect tag-placeholder="數字為1~31"  v-model="process.start_value"
                            placeholder="新增日期 (格式為數字1~31)" label="label" track-by="value" :options="offdaySetting.options.monthDay"
                            :multiple="false" :taggable="true" @tag="addStartMonthDayTag" :id="'process-start-' + pIndex"></multiselect>
              </div>
            </div>
            <br />
          </div>
          <div v-if="process.value_type === 2">
            <div class="input-group">
            <span class="input-group-addon">
              結束
            </span>
              <div>
                <multiselect v-model="process.end_value"
                            placeholder="新增星期" label="label" track-by="value" :options="offdaySetting.options.weekDay"
                            :multiple="false" :allow-empty="true"></multiselect>
              </div>
            </div>
            <br />
          </div>
          <div v-if="process.value_type === 1">
            <div class="input-group">
            <span class="input-group-addon">
              結束
            </span>
              <div>
                <multiselect tag-placeholder="數字為1~31" v-model="process.end_value"
                            placeholder="新增日期 (格式為數字1~31)" label="label" track-by="value" :options="offdaySetting.options.monthDay"
                            :multiple="false" :taggable="true" @tag="addEndMonthDayTag"></multiselect>
              </div>
            </div>
            <br />
          </div>
          <div>
            <div class="input-group">
            <span class="input-group-addon">
              取餐類型
            </span>
              <div>
                <multiselect v-model="process.delivery_type"
                            placeholder="選擇取餐類型" label="label" track-by="value" :options="deliveryTypeOption"
                            :multiple="false" :allow-empty="true"></multiselect>
              </div>
            </div>
            <br />
          </div>
          <div class="text-left"><button class="btn btn-primary" @click="addItemTime(process)">加入時間</button></div>
          <table class="table table-bordered table-striped dataTable">
            <thead class="bg-primary">
            <tr>
              <td>開始時間</td>
              <td>結束時間</td>
              <td>準備時間</td>
              <td></td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, iIndex) in process.item_list">
              <td>
                <input class="form-control w-90 inline-block" placeholder="hh:mm:ss" type="text" v-model="item.start_time">
              </td>
              <td>
                <input class="form-control w-90 inline-block" placeholder="hh:mm:ss" type="text" v-model="item.end_time">
              </td>
              <td>
                <input class="form-control w-90 inline-block" placeholder="" type="text" v-model="item.process_time" @keypress="returnNum">&nbsp;&nbsp;分鐘
              </td>
              <td>
                <button class="btn btn-danger" v-if="iIndex > 0" @click="removeListItem(process.item_list, iIndex)"><i class="fa fa-trash"></i></button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- End 製作/取餐時間 -->

      <!-- 取餐方式/門檻 -->
      <div class="box-body form" v-show="storeMethod === 6">
        <div><h3>取餐方式/門檻</h3></div>
        <br />
        <h5 class="text-left"><span class="text-red">＊</span> 外送的"消費金額與距離門檻"設定為群組功能，需將每個級距規則一併設定後才可進行修改。</h5>
        <h5 class="text-left"><span class="text-red">＊</span> 於單一門市資訊已設為預設的取餐方式，不可於此處設定為關閉，該門市關閉設定將不被覆蓋。</h5>
        <h5 class="text-left"><span class="text-red">＊</span> 當門市的取餐類型為"不支援"時，若在此設定為開啟，該門市開啟狀態將維持關閉。</h5>
        <div v-if="reCheckOption.body" class="hint mb-1">
          <i class="fa fa-close re-check-close" @click="invalidStoreMap=null"></i>
          <span v-html="reCheckOption.body"></span>
        </div>

        <div class="table-responsive">
          <table class="table table-bordered table-striped dataTable">
            <thead class="bg-primary">
            <tr>
              <td>取餐類型</td>
              <td v-if="getRoleType == 99">支援與否</td>
              <td>開啟狀態</td>
              <td>
                預設
                <span class="nd-tooltip">
                  <ion-icon name="help-circle"></ion-icon>
                  <span class="nd-tooltip-text center">
                    購物車預設的取餐方式。開啟狀態為 "開啟" 的取餐方式才能設為預設。
                  </span>
                </span>
              </td>
              <td>
                <span>消費金額與距離門檻</span>
                <span class="nd-tooltip">
                  <ion-icon name="help-circle"></ion-icon>
                  <span class="nd-tooltip-text text-align-left">
                    ．計算商品金額 (折扣後) ，不含塑膠袋。<br/>
                    ．0元為最低消費金額
                  </span>
                </span>
              </td>
              <td>
                <span>備註</span>
                <span class="nd-tooltip">
                  <ion-icon name="help-circle"></ion-icon>
                  <span class="nd-tooltip-text">
                    顯示在購物車頁面上，消費者可查看，前台顯示畫面，如下方粉色備註區塊
                    <img alt="備註描述圖片" src='/static/img/delivery_memo_ex.png' />
                  </span>
                </span>
              </td>
              <td>
                <span>取餐提醒</span>
                <span class="nd-tooltip">
                  <ion-icon name="help-circle"></ion-icon>
                  <span class="nd-tooltip-text">
                    顯示在訂單確認頁面上，消費者可查看，如預覽圖所示。
                    <img alt="取餐提醒圖片" src='/static/img/delivery_pickup_memo.png' />
                  </span>
                </span>
              </td>
            </tr>
            </thead>
            <tbody>
            <tr
              v-for="(deliveryWays,dIndex) in deliveryWaysInfo"
              :key="dIndex"
              v-show="!hideDeliveryType.includes(deliveryWays.take_type)">
              <!-- 取餐類型 -->
              <td>{{deliveryWays.take_type | deliveryName}}</td>
              <!-- End 取餐類型 -->

              <!-- 支援與否 -->
              <td v-if="getRoleType == 99">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input
                        type="radio"
                        value="1"
                        v-model="deliveryWays.is_support"
                      >
                      支援
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input
                        @change="clickClose('deliveryWays', true, deliveryWays.is_default, dIndex)"
                        type="radio"
                        value="0"
                        v-model="deliveryWays.is_support"
                      >
                      不支援
                    </label>
                  </div>
                </div>
              </td>
              <!-- End 支援與否 -->

              <!-- 開啟狀態 -->
              <td>
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input
                        type="radio"
                        :disabled="parseInt(deliveryWays.is_support, 10) === 0"
                        value="1"
                        v-model="deliveryWays.is_enable"
                      />
                        <span :class="{ 'radio-text--disabled': deliveryWays.is_support == 0 }">
                          開啟
                        </span>
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input
                        type="radio"
                        value="0"
                        v-model="deliveryWays.is_enable"
                        :disabled="parseInt(deliveryWays.is_support, 10) === 0 "
                        @change="clickClose('deliveryWays', false, deliveryWays.is_default, dIndex)"
                      />
                        <span :class="{ 'radio-text--disabled': deliveryWays.is_support == 0 }">
                          關閉
                        </span>
                    </label>
                  </div>
                </div>
              </td>
              <!-- End 開啟狀態 -->

              <!-- 預設 -->
              <td>
                <label v-if="deliveryWays.take_type !== 21">
                  <input
                    type="radio"
                    value="1"
                    :disabled="parseInt(deliveryWays.is_support, 10) === 0 || parseInt(deliveryWays.is_enable, 10) === 0"
                    v-model="deliveryWays.is_default"
                    @change="checkDefault(deliveryWays.take_type)"
                  />
                </label>
              </td>
              <!-- End 預設 -->

              <!-- 消費金額與距離門檻 -->
              <td v-if="deliveryWays.take_type !== 3">
                滿&nbsp;&nbsp;<input class="form-control w-90 inline-block" placeholder="" type="text" v-model="deliveryWays.price" @keypress="returnNum">&nbsp;&nbsp;元即可{{deliveryWays.take_type | deliveryName}}
              </td>
              <td v-if="deliveryWays.take_type === 3">
                <delivery-limit
                  :store-info="storeInfo"
                  :delivery-ways="deliveryWays"
                  :delivery-ways-info="deliveryWaysInfo"
                  :delivery-other="deliveryOther"
                  @update:deliveryWaysInfo="deliveryWaysInfo = $event"
                  @update:deliveryOther="deliveryOther = $event"
                  @update:storeInfo="storeInfo = $event"
                  @update:deliveryWays="deliveryWays = $event"
                ></delivery-limit>
              </td>
              <!-- 消費金額與距離門檻 -->

              <!-- 備註 -->
              <td>
                <textarea v-model="deliveryWays.memo" class="w-100-p form-control" rows="2" :maxlength="remarkMaxlength"></textarea>
                <div class="text-right">{{ deliveryWays.memo?deliveryWays.memo.length:0 }}/{{remarkMaxlength}}</div>
              </td>
              <!-- End 備註 -->
              <!-- 取餐提醒 -->
              <td>
                <textarea v-model="deliveryWays.pickup_memo" :disabled="getRoleType === 10 && deliveryWays.is_support === 0" class="w-100-p form-control" rows="2" :maxlength="remarkMaxlength"></textarea>
                <div class="text-right">{{ deliveryWays.pickup_memo?deliveryWays.pickup_memo.length:0 }}/{{remarkMaxlength}}</div>
              </td>
              <!-- End 取餐提醒 -->
            </tr>
            </tbody>
          </table>
        </div>
        <br>

        <!-- 運費設定 -->
        <shipping-form ref="shippingInfo" :store-info="storeInfo" :resetShopping="resetShopping" @update:store-info="storeInfo = $event"></shipping-form>
        <!-- End 運費設定 -->
        <br>

        <!-- 桌號設定 -->
        <div>
          <h3>桌號設定</h3>

          <!-- 送餐方式 -->
          <div class="input-group">
            <span class="input-group-addon">
              送餐方式
            </span>
            <div class="form-group">
              <div class="form-group text-left">
                <div class="radio inline-block">
                  <label>
                    <input v-model="tableNumber.sub_delivery_type" type="radio" :value="1">
                    叫號取餐
                  </label>
                </div>
                <div class="radio inline-block">
                  <label>
                    <input v-model="tableNumber.sub_delivery_type" type="radio" :value="2">
                    店家送餐
                  </label>
                </div>
              </div>
            </div>
          </div>
          <br />
          <!-- End 送餐方式 -->

          <!-- 桌號必填 -->
          <div v-if="tableNumber.sub_delivery_type === 2">
            <div class="input-group">
              <span class="input-group-addon">桌號必填</span>
              <div class="form-group">
                <select v-model="tableNumber.is_table_no_required" class="form-control">
                  <option :value="0">非必填</option>
                  <option :value="1">必填</option>
                </select>
              </div>
            </div>
            <br>
          </div>
          <!-- End 桌號必填 -->

          <!-- 桌號編輯 -->
          <div v-if="tableNumber.sub_delivery_type === 2">
            <div class="input-group">
              <span class="input-group-addon">
                桌號編輯
              </span>
              <div class="form-group">
                <select v-model="tableNumber.is_table_no_editable" class="form-control">
                  <option :value="0">不可編輯</option>
                  <option :value="1">可編輯</option>
                </select>
              </div>
            </div>
            <br>
          </div>
          <!-- End 桌號編輯 -->

          <!-- 桌號顯示 -->
          <div v-if="tableNumber.sub_delivery_type === 2">
            <div class="input-group">
              <span class="input-group-addon">
                桌號顯示
              </span>
              <div class="form-group">
                <select v-model="tableNumber.show_table_no" class="form-control">
                  <option :value="1">顯示</option>
                  <option :value="0">隱藏</option>
                </select>
              </div>
            </div>
            <br>
          </div>
          <!-- End 桌號顯示 -->

          <!-- 訪客下單 -->
          <div>
            <div class="input-group">
              <span class="input-group-addon">
                訪客下單
              </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div v-for="(deliveryWays, i) in deliveryWaysInfo" :key="i" v-if="deliveryWays.take_type === 21">
                    <div class="radio inline-block">
                      <label>
                        <input v-model="deliveryWays.is_allow_guest_order" type="radio" :value="1">
                        開啟
                      </label>
                    </div>
                    <div class="radio inline-block">
                      <label>
                        <input v-model="deliveryWays.is_allow_guest_order" type="radio" :value="0">
                        關閉
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
          <!-- End 訪客下單 -->

          <!-- 預設登入方式 -->
          <div v-for="(deliveryWays, i) in deliveryWaysInfo" :key="i" v-if="deliveryWays.take_type === 21 && deliveryWays.is_allow_guest_order === 1">
            <div class="input-group">
              <span class="input-group-addon">
                預設登入方式
              </span>
              <div class="form-group">
                <select v-model="tableNumber.default_login_type" class="form-control">
                  <option :value="1">會員</option>
                  <option :value="2">訪客</option>
                </select>
              </div>
            </div>
            <br>
          </div>
          <!-- End 預設登入方式 -->
        </div>
        <!-- End 桌號設定 -->

        <!-- 排除設定 -->
        <div v-if="getRoleType === 99 || getRoleType == 30"><h3>排除設定</h3></div>
        <div v-if="getRoleType === 99 || getRoleType == 30">
          <p>某時間(日期、星期、每月幾號)無法取餐(自取、外送、內用、桌邊掃碼)</p>
        </div>
        <br />
        <div v-if="getRoleType === 99 || getRoleType == 30" class="text-left">
          <button class="btn btn-success" @click="addExCalendar">新增店家排除時段設定</button>
        </div>
        <div class="m-t-10 process-time-block" v-for="(exCalendar, caIndex) in exceptionCalendar">
          <div class="text-right m-b-10">
            <button class="btn btn-danger" @click="removeListItem(exceptionCalendar, caIndex)"><i class="fa fa-trash"></i></button></div>
          <div>
            <div class="input-group">
              <span class="input-group-addon">排除取餐類型</span>
              <div class="form-group">
                <select class="form-control" v-model="exCalendar.delivery_type">
                  <option :value="delivery.value" v-for="delivery in deliveryInfo">{{delivery.label}}</option>
                </select>
              </div>
            </div>
            <br>
          </div>
          <div class="text-left"><button class="btn btn-primary" @click="addExDate(exCalendar)">加入指定日期</button></div>
          <table class="table table-bordered table-striped dataTable" v-if="exCalendar.date_type.length">
            <thead class="bg-primary">
            <tr>
              <td>指定日期</td>
              <td>開始時間</td>
              <td>結束時間</td>
              <td></td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, daIndex) in exCalendar.date_type">
              <td>
                <input class="form-control inline-block" placeholder="YYYY-MM-DD" type="text" v-model="item.date">&nbsp;&nbsp;
              </td>
              <td>
                <input class="form-control w-90 inline-block" placeholder="hh:mm:ss" type="text" v-model="item.start_time">
              </td>
              <td>
                <input class="form-control w-90 inline-block" placeholder="hh:mm:ss" type="text" v-model="item.end_time">
              </td>
              <td>
                <button class="btn btn-danger" @click="removeListItem(exCalendar.date_type, daIndex)"><i class="fa fa-trash"></i></button>
              </td>
            </tr>
            </tbody>
          </table>
          <br>
          <div class="text-left"><button class="btn btn-primary" @click="addExWeekDay(exCalendar)">加入星期</button></div>
          <table class="table table-bordered table-striped dataTable" v-if="exCalendar.week_day.length">
            <thead class="bg-primary">
            <tr>
              <td>星期</td>
              <td>開始時間</td>
              <td>結束時間</td>
              <td></td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, weIndex) in exCalendar.week_day">
              <td>
                <select class="form-control" v-model="item.day">
                  <option :value="weekDay.value" v-for="weekDay in offdaySetting.options.weekDay" v-if="weekDay.value">
                    {{weekDay.label}}
                  </option>
                </select>
              </td>
              <td>
                <input class="form-control w-90 inline-block" placeholder="hh:mm:ss" type="text" v-model="item.start_time">
              </td>
              <td>
                <input class="form-control w-90 inline-block" placeholder="hh:mm:ss" type="text" v-model="item.end_time">
              </td>
              <td>
                <button class="btn btn-danger" @click="removeListItem(exCalendar.week_day, weIndex)"><i class="fa fa-trash"></i></button>
              </td>
            </tr>
            </tbody>
          </table>
          <br>
          <div class="text-left"><button class="btn btn-primary" @click="addExMonthDay(exCalendar)">加入每月幾號</button></div>
          <table class="table table-bordered table-striped dataTable" v-if="exCalendar.month_day.length">
            <thead class="bg-primary">
            <tr>
              <td>每月幾號</td>
              <td>開始時間</td>
              <td>結束時間</td>
              <td></td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, moIndex) in exCalendar.month_day">
              <td>
                每月<input class="form-control w-90 inline-block" placeholder="1-31" type="text" v-model="item.day">&nbsp;&nbsp;日
              </td>
              <td>
                <input class="form-control w-90 inline-block" placeholder="hh:mm:ss" type="text" v-model="item.start_time">
              </td>
              <td>
                <input class="form-control w-90 inline-block" placeholder="hh:mm:ss" type="text" v-model="item.end_time">
              </td>
              <td>
                <button class="btn btn-danger" @click="removeListItem(exCalendar.month_day, moIndex)"><i class="fa fa-trash"></i></button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <!-- End 排除設定 -->
        <!-- Start 取餐方式 關閉預設提醒 -->
        <button class="btn" ref="pickupWarnModal" v-show="false" data-toggle="modal" data-target="#pickupWarnModal"></button>
        <div class="modal fade text-left" role="dialog" id="pickupWarnModal">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
                <h4 class="modal-title">提醒</h4>
              </div>
              <div class="modal-body">
                預設項目不可關閉，請先調整預設的取餐類型
              </div>
              <div class="modal-footer">
                <button class="btn btn-default" data-dismiss="modal">確定</button>
              </div>
            </div>
          </div>
        </div>
        <!-- End 取餐方式 關閉預設提醒 -->
      </div>
      <!-- End 取餐方式/門檻 -->

      <!-- 營業時間 -->
      <div class="box-body form" v-show="storeMethod === 7">
        <div><h3>營業時間</h3></div>
        <br />
        <h5 class="text-left"><span class="text-red">＊</span> 各列設定為群組功能，需將每個星期的的"營業時間+打烊時間"一併設定後才可進行修改。</h5>
        <div class="table-responsive" style="overflow: inherit;">
          <table class="table table-bordered table-striped dataTable">
            <thead class="bg-primary">
            <tr>
              <td>星期</td>
              <td>營業時間</td>
              <td>打烊時間</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="weekDay in openingInfo">
              <td>{{getWeekDayName(weekDay.week_day)}}</td>
              <td>
                <input class="form-control w-90 inline-block" placeholder="hh:mm" type="text" v-model="weekDay.start" @blur="validateTimeRange(weekDay, 'start', 'end')"/>
              </td>
              <td>
                <input class="form-control w-90 inline-block" placeholder="hh:mm" type="text" v-model="weekDay.end" @blur="validateTimeRange(weekDay, 'start', 'end')"/>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <br />
        <div class="text-left">
          <button class="btn btn-success" @click="addSpecialDay">新增指定日期</button>
        </div>
        <div class="m-t-10" v-if="selectSpecialDay.length">
          <h5 class="text-left"><span class="text-red">＊</span> 設定完成後，指定日期將套用此營業時間顯示，期間結束後即恢復預設營業時間。</h5>
          <h5 class="text-left"><span class="text-red">＊</span> 若與公休日期重複，會優先顯示指定日期的營業時間。</h5>
          <!-- TO DO: 本頁的 <FunctionalCalendar> 元件們的使用待開維運單，可能調整成 dialog 的形式或是找其他支援 RWD 元件替換（StoreFormTemp.vue） -->
          <div class="table-responsive specialDayCalendarTable-responsive">
            <table class="table table-bordered table-striped dataTable" >
              <thead class="bg-primary sticky-header">
              <tr>
                <td>指定日期</td>
                <td>營業時間</td>
                <td>打烊時間</td>
                <td>備註
                  <span class="nd-tooltip">
                  <ion-icon name="help-circle"></ion-icon>
                  <span class="nd-tooltip-text">
                    顯示在前台門市營業時間後方，如下範例：<br>
                    <img src='/static/img/specialDay_remark_tooltips.png'>
                  </span>
                </span>
                </td>
                <td></td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, daIndex) in selectSpecialDay">
                <td class="date-picker-cell">
                  <div class="calendar-container">
                    <div class="calendar" v-if="item.showSpecialDayCalendar" >
                      <FunctionalCalendar
                        v-model="tempSpecialDayCalendar"
                        :is-multiple-date-picker='true'
                        :limits= "calendarLimits"
                        @dayClicked="specialDayCalendarSelected(daIndex, $event)"
                      />
                      <div class="calenderClose"><button class="btn btn-primary btn-xs btn-close" @click="item.showSpecialDayCalendar=false">
                        關閉
                      </button></div>
                    </div>
                    <multiselect
                      class="calendar-multiselect"
                      v-model="item.calendar_list"
                      tag-placeholder="格式為YYYY-MM-DD"
                      placeholder="新增日期 (格式為YYYY-MM-DD)"
                      label="label"
                      track-by="value"
                      :options="offdaySetting.options.date"
                      :multiple="true"
                      :optionsLimit="0"
                      :hideSelected="true"
                      @remove="removeTag('specialDay', daIndex, val)"
                      @open="openSpecialDayCalendar(daIndex)"
                    ∂>
                    </multiselect>
                  </div>
                </td>
                <td>
                  <input class="form-control w-90 inline-block" placeholder="hh:mm" type="text" v-model="item.start_time" @blur="validateTimeRange(item)">
                </td>
                <td>
                  <input class="form-control w-90 inline-block" placeholder="hh:mm" type="text" v-model="item.end_time" @blur="validateTimeRange(item)">
                </td>
                <td class="remark-cell">
                  <textarea v-model="item.remark" class="w-100-p form-control" rows="1" :maxlength="specialDayRemarkMaxlength"></textarea>
                  <div class="text-right">{{ (item.remark || '').length }}/{{ specialDayRemarkMaxlength }}</div>
                </td>
                <td>
                  <button class="btn btn-danger" @click="removeListItem(selectSpecialDay, daIndex)"><i class="fa fa-trash"></i></button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div><h3>公休時間</h3></div>
        <div v-if="getRoleType === 99 || getRoleType == 30">
          <div class="input-group">
          <span class="input-group-addon">
            公休時間下單
          </span>
            <div class="form-group">
              <div class="form-group text-left">
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="isOffAllow" :value="1" v-model="storeInfo.is_off_allow_order">可下單
                  </label>
                </div>
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="isOffAllow" :value="0" v-model="storeInfo.is_off_allow_order">不可下單
                  </label>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              指定日期
            </span>
            <div class="calendar-container">
              <div class="calendar" v-if="showCalendar" @blur="showCalendar=false">
                <FunctionalCalendar
                  v-model="selectDate"
                  :is-multiple-date-picker='true'
                  :limits="calendarLimits"
                  @dayClicked="calendarSelected"
                />
                <div class="calenderClose"><button class="btn btn-primary btn-xs btn-close nd-ml-5" @click="showCalendar=false">
                  關閉
                </button></div>
              </div>
              <multiselect
                class="calendar-multiselect"
                v-model="offdaySetting.date"
                tag-placeholder="格式為YYYY-MM-DD"
                placeholder="新增日期 (格式為YYYY-MM-DD)"
                label="label"
                track-by="value"
                :options="offdaySetting.options.date"
                :multiple="true"
                :optionsLimit="0"
                :hideSelected="true"
                @remove="removeTag('date', 0, $event)"
                @open="openDateCalendar"
              >
              </multiselect>
            </div>
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              每週幾
            </span>
            <div>
              <multiselect
                v-model="offdaySetting.weekDay"
                placeholder="新增日期"
                label="label"
                track-by="value" 
                :options="offdayWeekDayOptions"
                :multiple="true"
                :allow-empty="true"
              >
              </multiselect>
            </div>
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              每月幾號
            </span>
            <div>
              <multiselect v-model="offdaySetting.monthDay" tag-placeholder="數字為1~31"
                          placeholder="新增日期 (格式為數字1~31)" label="label" track-by="value" :options="offdayMonthDayOptions"
                          :multiple="true" :taggable="true" @tag="addMonthDayTag"></multiselect>
            </div>
          </div>
          <br />
        </div>
        <br />
      </div>
      <!-- End 營業時間 -->

      <!-- 塑膠袋設定 -->
      <div class="box-body form" v-show="storeMethod === 8">
        <div v-if="getRoleType === 99 || getRoleType === 30 || getRoleType === 10">
          <div><h3>塑膠袋設定</h3></div>
          <br />
          <div>
            <div class="input-group">
              <span class="input-group-addon">
                塑膠袋功能
                <span class="nd-tooltip">
                  <i class="fa fa-question-circle" aria-hidden="true"></i>
                  <span class="nd-tooltip-text alliance-tooltip">
                    「 塑膠袋功能 」將顯示於購車第一步驟，提供消費者選擇。
                    <img src="/static/img/plastic-select-sample-img.png" />
                  </span>
                </span>
              </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="plasticOption" value="1" v-model="plasticSelect">開啟（此功能需於菜單上架塑膠袋商品方可支援）
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="plasticOption" value="0" v-model="plasticSelect">關閉
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
          <div>
            <div class="input-group">
              <span class="input-group-addon">
                塑膠袋數量可自行調整
                <span class="nd-tooltip">
                  <i class="fa fa-question-circle" aria-hidden="true"></i>
                  <span class="nd-tooltip-text" v-text="'消費者可否在購物車中自行調整塑膠袋的數量'" />
                </span>
              </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="plasticAmountAdjustable" value="1" v-model="plasticAmountAdjustable">開啟
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="plasticAmountAdjustable" value="0" v-model="plasticAmountAdjustable">關閉
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
          <div>
            <div class="input-group">
              <span class="input-group-addon">
                塑膠袋單位(幾份商品一個塑膠袋)
              </span>
              <input class="form-control" placeholder="" type="text" v-model.number.trim="storeInfo.plastic_unit">
            </div>
            <br />
          </div>
          <div>
            <div class="input-group">
              <span class="input-group-addon">
                預設勾選塑膠袋
              </span>
              <div>
                <multiselect v-model="deliveryWayPlastic" placeholder="選擇取餐方式" label="label" track-by="value"
                  :options="deliveryInfo" :multiple="true" :allow-empty="true"></multiselect>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
      <!-- End 塑膠袋設定 -->

      <!-- 出單機設定 -->
      <shipping-form ref="shipping" :resetShopping="resetShopping" v-show="storeMethod === 9"></shipping-form>
      <div class="box-body form" v-show="storeMethod === 10">
        <div><h3>出單機設定</h3></div>
        <br />
        <div class="row" v-if="printerStoreList.length">
          <div class="col-sm-12 table-responsive p-x-0">
            <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
              <thead>
              <tr role="row">
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">出單機名稱(ID)</th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">綁定名稱(ID)</th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">類型</th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">辨識碼</th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">出單機啟用</th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">綁定機啟用</th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
                <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
              </tr>
              </thead>
              <tbody>
              <tr class="even" role="row" v-for="(printer, index) in printerStoreList">
                <!-- cloumn 0 -->
                <td class="sorting_1">{{index + 1}}</td>
                <td>
                  出單機{{printer.printer_id}}號 ({{printer.printer_id}})
                </td>
                <td>
                  {{printer.binding_name}} ({{printer.binding_id}})
                </td>
                <td>{{printerType(printer.printer_type)}}</td>
                <td>{{printer.printer_identity}}</td>
                <td>
                  <span v-if="printer.printer_is_enabled" class="label label-success">啟用</span>
                  <span v-if="!printer.printer_is_enabled"  class="label label-danger">未啟用</span>
                </td>
                <td>
                  <span v-if="printer.binding_is_enabled" class="label label-success">啟用</span>
                  <span v-if="!printer.binding_is_enabled"  class="label label-danger">未啟用</span>
                </td>
                <td>
                  <button class="btn btn-default" data-toggle="modal" data-target="#editModal" @click="getCurrent(printer)"><i class="fa fa-pencil"></i></button>
                </td>
                <td>
                  <button class="btn btn-danger" data-toggle="modal" data-target="#delModal" @click="getCurrent(printer)"><i class="fa fa-trash"></i></button>
                </td>
              </tr>
              </tbody>
            </table>
            <br>
          </div>
        </div>
        <div>
          <div class="input-group">
          <span class="input-group-addon">
            方式
          </span>
            <div class="form-group">
              <select class="form-control" v-model="printerSelect">
                <option :value="1">新增</option>
                <option :value="2">使用現有</option>
              </select>
            </div>
          </div>
          <br />
        </div>
        <div v-if="printerSelect === 1">
          <div class="input-group">
          <span class="input-group-addon">
            識別碼
          </span>
            <input class="form-control" placeholder="" type="text" v-model="printerInfo.identity" maxlength="45">
          </div>
          <br />
        </div>
        <div v-if="printerSelect === 1">
          <div class="input-group">
          <span class="input-group-addon">
            類型
          </span>
            <div class="form-group">
              <select class="form-control" v-model="printerInfo.type">
                <option :value="1">W牌出單機(1)</option>
                <option :value="2">F牌出單機(2)</option>
                <option :value="3">F牌貼紙機(3)</option>
              </select>
            </div>
          </div>
          <br />
        </div>
        <div v-if="printerSelect === 2">
          <div class="input-group">
          <span class="input-group-addon">
            選擇出單機
          </span>
            <div class="form-group">
              <select class="form-control" v-model="isPrinterSelect">
                <option :value="printer.printer_id" v-for="printer in printerList">{{printer.printer_identity}}</option>
              </select>
            </div>
          </div>
        </div>
        <!-- 綁定按鈕 -->
        <button class="btn btn-success" v-if="storeMethod === 10" @click="checkPrinter">
          綁定
        </button>
        <br>
        <hr class="m-t-20">
        <br>
        <div v-if="printerLayoutSetting.length">
          <div><h3>出單機列印格式設定</h3></div>
          <br />
          <div class="row">
            <div class="col-sm-12 table-responsive p-x-0">
              <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                <thead>
                <tr role="row">
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">列印格式</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">觸發類型</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">啟用</th>
                </tr>
                </thead>
                <tbody>
                <tr class="even" role="row" v-for="(printer, index) in printerLayoutSetting">
                  <!-- cloumn 0 -->
                  <td class="sorting_1">{{index + 1}}</td>
                  <td>
                    {{printer.layout_name}}
                  </td>
                  <td>
                    <div class="radio inline-block">
                      <label>
                        <input type="radio" :name="'triggerType' + index" :value="1" v-model="printer.trigger_type">手動
                      </label>
                    </div>
                    <div class="radio inline-block">
                      <label>
                        <input type="radio" :name="'triggerType' + index" :value="2" v-model="printer.trigger_type">自動
                      </label>
                    </div>
                    <!-- <span v-if="printer.printer_is_enabled" class="label label-success">啟用</span>
                    <span v-if="!printer.printer_is_enabled"  class="label label-danger">未啟用</span> -->
                  </td>
                  <td>
                    <div class="radio inline-block">
                      <label>
                        <input type="radio" :name="'isEnable' + index" :value="1" v-model="printer.is_enabled">啟用
                      </label>
                    </div>
                    <div class="radio inline-block">
                      <label>
                        <input type="radio" :name="'isEnable' + index"  :value="0" v-model="printer.is_enabled">未啟用
                      </label>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
              <br>
            </div>
          </div>
        </div>
      </div>
      <!-- End 出單機設定 -->

      <!-- 網址設定 -->
      <div class="box-body form" v-show="storeMethod === 11 && $route.name !== 'crStore'">
        <div><h3>網址設定</h3></div>
        <br />
        <div class="text-left"><span class="text-red">＊</span> 若開啟內用-桌邊掃碼取餐類型，門市可利用網址設定功能，新增桌號並獲取各桌獨立網址，將該網址轉為QRCode後即可運用於提供給顧客做桌邊掃碼點餐。</div>
        <div class="table-responsive m-b-15">
          <table class="table table-bordered table-striped dataTable">
            <thead class="bg-primary">
              <tr>
                <td>入口</td>
                <td>桌號
                  <span class="nd-tooltip">
                    <ion-icon name="help-circle"></ion-icon>
                    <span class="nd-tooltip-text center">
                      限10字以內，僅限英數大小寫不可符號，桌號間請使用「，」分隔。
                    </span>
                  </span>
                </td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <select class="form-control" v-model="tableNumberUrl.type">
                    <option v-for="item in enterType" :key="`enter-${item.value}`" :value="item.value">{{item.name}}</option>
                  </select>
                </td>
                <td>
                  <textarea v-model.trim="tableNumberUrl.text" rows="3" class="form-control inline-block" placeholder="範例：A01,A02,A03..."></textarea>
                </td>
                <td>
                  <div @click="exportUrl" class="btn btn-default btn-table-title">匯出網址</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- End 網址設定 -->

      <!-- 計費方式設定 -->
      <div class="box-body form" v-show="storeMethod === 12">
        <div><h3>計費方式設定</h3></div>
        <br />
        <div>
          <div class="input-group">
            <span class="input-group-addon">
              選擇計費方式
            </span>
            <div class="form-group">
              <select class="form-control" v-model="orderCommissionSetting.type">
                <option :value="1">系統費</option>
                <option :value="2">系統費+資訊服務費抽成</option>
                <option :value="3">資訊服務費抽成</option>
              </select>
            </div>
          </div>
          <br />
        </div>
        <!-- 資訊服務抽成設定 - Start -->
        <div v-if="orderCommissionSetting.type > 1" class="text-left">
          <div>
            <h5><span class="text-red">＊</span>新增資訊服務費抽成設定為群組功能，無法單獨設定。</h5>
            <button
              class="btn btn-success"
              @click="orderCommissionSetting.item_list.push(JSON.parse(JSON.stringify(commissionItemList)))"
            >
              新增資訊服務費抽成設定
            </button>
          </div>
          <div
            v-for="(item, pIndex) in orderCommissionSetting.item_list"
            :key="pIndex"
            :class="['process-time-block', { 'm-t-10': pIndex !== 0 }, { 'overlap': showOverlapErrorIndex.includes(pIndex) }]"
          >
            <div class="text-right m-b-10">
              <!-- 刪除按鈕 -->
              <button
                class="btn btn-danger"
                @click="removeListItem(orderCommissionSetting.item_list, pIndex)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  資訊服務費抽成%
                  <span
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="請勿輸入空格"
                  >
                    <i class="fa fa-question-circle" aria-hidden="true" />
                  </span>
                </span>
                <input class="form-control" placeholder="輸入數字" type="number" maxlength="2" v-model="item.ratio">
                <span class="input-addon-icon">
                  %
                </span>
              </div>
              <br>
              <div class="input-group">
                <span class="input-group-addon">
                  取貨方式
                </span>
                <div class="form-group">
                  <select class="form-control" v-model="item.delivery_type">
                    <option :value="0">全部</option>
                    <option
                      v-for="delivery in supportDeliveryOption"
                      :key="`takeType${delivery.value}`"
                      :value="delivery.value"
                    >
                      {{ delivery.label }}
                    </option>
                  </select>
                </div>
              </div>
              <br>
              <div class="table-row">
                <div class="table-cell">
                  抽成生效日
                  <span
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="系統依據該日期開始計算到資訊服務費抽成報表"
                  >
                    <i class="fa fa-question-circle" aria-hidden="true" />
                  </span>
                </div>
                <div class="table-from">
                  <date-picker
                    v-model="item.start_time"
                    class="hide-date-icon"
                    :show-second="false"
                    type="datetime"
                    valueType="format"
                    format="YYYY-MM-DD HH:mm"
                    input-class="form-control"
                    placeholder="新增日期 (格式為：YYYY-MM-DD HH:mm)"
                    :clearable="false"
                    :disabled-time="notBeforeTodayAddTwoMins"
                    :disabled-date="notBeforeToday"
                  />
                </div>
              </div>
              <div class="table-row p-t-10">
                <div class="table-cell">
                  抽成結束日
                  <span
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="系統依據該日期停止計算到資訊服務費抽成報表"
                  >
                    <i class="fa fa-question-circle" aria-hidden="true" />
                  </span>
                </div>
                <div class="table-from">
                  <date-picker
                    v-model="item.end_time"
                    class="hide-date-icon"
                    :show-second="false"
                    type="datetime"
                    valueType="format"
                    format="YYYY-MM-DD HH:mm"
                    input-class="form-control"
                    placeholder="新增日期 (格式為：YYYY-MM-DD HH:mm)"
                    :clearable="false"
                    :disabled-time="notBeforeTodayAddTwoMins"
                    :disabled-date="notBeforeToday"
                  />
                </div>
              </div>
            </div>
          </div>
          <br>
        </div>
        <!-- 資訊服務抽成設定 - End -->
        <div v-if="orderCommissionSetting.type !== 1">
            <!-- 門市獨立產出抽成對帳表 - Start -->
            <div class="input-group">
              <span class="input-group-addon">
                門市獨立產出抽成對帳表/計算作廢額度
                <span
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="適用於門市獨立簽約的類型"
                >
                  <i class="fa fa-question-circle" aria-hidden="true" />
                </span>
              </span>
              <div class="form-group">
                <div class="form-group text-left">
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="independent" :value="1" v-model="orderCommissionSetting.has_independent_report">是
                    </label>
                  </div>
                  <div class="radio inline-block">
                    <label>
                      <input type="radio" name="independent" :value="0" v-model="orderCommissionSetting.has_independent_report">否
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- 門市獨立產出抽成對帳表 - End -->
            <br />

            <!-- 門市作廢訂單額度 - Start -->
            <div v-if="orderCommissionSetting.has_independent_report === 1" class="input-group">
              <span class="input-group-addon">
                門市每月作廢訂單額度(筆)
              </span>
              <input class="form-control" type="number" maxlength="10" v-model="orderCommissionSetting.allow_invalid_order_quota">
            </div>
            <!-- 門市作廢訂單額度 - End -->

            <!-- 品牌作廢訂單額度 - Start -->
            <div v-if="orderCommissionSetting.has_independent_report === 0">
              <h5 class="text-left"> <span class="text-red">＊</span>可至「編輯品牌」調整作廢訂單額度。</h5>
              <div class="input-group">
                <span class="input-group-addon">
                每月作廢訂單額度(筆)
                <span
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="此為整個品牌的作廢訂單總額度，非單一門市；若修改會同步更新其他門市此欄位值"
                >
                  <i class="fa fa-question-circle" aria-hidden="true" />
                </span>
              </span>
              <div class="flex align-center">
                <span class="w-35 text-left m-l-15">{{ brandInvalidQuota }}</span>
              </div>
              </div>
            </div>
            <!-- 品牌作廢訂單額度 - End -->
        </div>
      </div>
      <!-- End 計費方式設定 -->

      <!-- 物流設定 -->
      <div
        class="box-body form"
        v-show="storeMethod === 13"
      >
        <div>
          <h3>物流設定</h3>
        </div>
        <br />
        <div>
          <table class="table table-bordered table-striped dataTable">
            <thead class="bg-primary">
              <tr>
                <td>配送物流</td>
                <td>開啟狀態</td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(vendor, index) in storeInfo.store_shipping_vendor"
                :key="index"
              >
                <td>
                  {{ vendor.vendor_code | shippingVendorName }}
                </td>
                <td>
                  <div class="form-group text-left">
                    <div class="radio inline-block">
                      <label>
                        <input
                          type="radio"
                          value="1"
                          v-model="vendor.is_enable"
                          @input="setReload"
                        />
                        啟用
                      </label>
                    </div>
                    <div class="radio inline-block">
                      <label>
                        <input
                          type="radio"
                          value="0"
                          v-model="vendor.is_enable"
                          @input="setReload"
                        />
                        不啟用
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- End 物流設定 -->

      <!-- 特殊需求 -->
      <div class="box-body form" v-show="storeMethod === 15">
        <div v-if="getRoleType === 99 || getRoleType === 30 || getRoleType === 10">
          <div>
            <h3>特殊需求</h3>
            <div>請確認POS端是否支援此功能</div>
          </div>
          <br />
          <div>
            <div class="input-group">
              <span class="input-group-addon">
                <span class="text-red">＊</span>
                自選吸管或餐具功能
                <span class="nd-tooltip">
                  <i class="fa fa-question-circle" aria-hidden="true"></i>
                  <span class="nd-tooltip-text alliance-tooltip">
                    「 自選吸管或餐具功能 」 將顯示於購車第一步驟，提供消費者選擇。
                    <img src="/static/img/straw-option-sample-img.png" />
                  </span>
                </span>
              </span>
              <div class="flex align-center h-34">
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="showTablewareStrawOption" value="1" v-model.number="showTablewareStrawOption">開啟
                  </label>
                </div>
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="showTablewareStrawOption" value="0" v-model.number="showTablewareStrawOption">關閉
                  </label>
                </div>
              </div>
            </div>
            <br/>
          </div>
          <div>
            <div class="input-group">
              <span class="input-group-addon">
                <span class="text-red">＊ </span>預設吸管或餐具選項
              </span>
              <div class="flex align-center h-34">
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="setTablewareStrawDefaultVal" value="1" v-model.number="setTablewareStrawDefaultVal">開啟
                  </label>
                </div>
                <div class="radio inline-block">
                  <label>
                    <input type="radio" name="setTablewareStrawDefaultVal" value="0" v-model.number="setTablewareStrawDefaultVal">關閉
                  </label>
                </div>
              </div>
            </div>
            <br/>
          </div>
        </div>
      </div>
      <!-- End 特殊需求-->

    <div class="pb-10">
      <button class="btn btn-default" @click="goToStoreTable">
        取消
      </button>
      <button class="btn btn-success" ref="modal" data-toggle="modal" data-target="#selectStoreModal">
        完成並選擇門市
      </button>
    </div>
    <m-modal class="text-left" :option="reCheckOption" @trigger="trigger"></m-modal>
    <m-modal class="text-left" :option="delOption" @trigger="trigger"></m-modal>
    <m-modal class="text-left" :option="updateOption" @trigger="trigger"></m-modal>
    <m-modal class="text-left" :option="editOption" :selectChange="selectChange" :selectOptions="selectOptions" @trigger="trigger" @selectOnChange="selectOnChange" @inputOnChange="inputOnChange"></m-modal>
  </div>
  <br/>

  <div class="modal fade" id="selectStoreModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content p-a-0">
        <div class="modal-header border-bottom pa-20">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title" id="myModalLabel">批次門市設定</h4>
        </div>
        <div class="modal-body pa-20">
          <div>請選取所有欲套用設定的門市至右側「套用門市」區塊，按下「確認變更」後指定的變更項目將覆蓋門市原有設定並立即套用。</div>
          <br />
          <div class="flex">
            <div class="form-group mr-10">
            <select class="form-control h-38" v-model="form.statusSelect">
              <option v-for="(type, index) in statusTypeList" :value="type.value" :key="`option-${index}`">
                {{type.label}}
              </option>
            </select>
          </div>
          <div class="form-group mr-10">
            <select class="form-control h-38" v-model="form.orderStatusSelect">
              <option :value="99">== 接單狀態 ==</option>
              <option :value="10">接單中</option>
              <option :value="20">不接單</option>
            </select>
          </div>
          <div class="form-group">
            <select class="form-control h-38" v-model="form.isSearchSelect">
              <option :value="99">== 搜尋狀態 ==</option>
              <option :value="1">可搜尋</option>
              <option :value="0">不可搜尋</option>
            </select>
          </div>
          </div>
          <div class="flex text-blod">
            <h5 style="width: 315px">不套用門市</h5>
            <h5>套用門市</h5>
          </div>
          <muti-select-two :setting="includeStoresSetting" :reNew="reNew" :reSet="reSet"></muti-select-two>
        </div>
        <div class="modal-footer" style="display: flex; justify-content: end;">
          <button type="button" class="btn btn-default bt-c" data-dismiss="modal">取消</button>
          <button type="button" class="btn btn-default bt-c" data-dismiss="modal" ref="modal" data-toggle="modal" data-target="#updateModal">確認變更</button>
          <button id="reCheckButton" type="button" data-dismiss="modal" ref="modal" data-toggle="modal" data-target="#reCheckModal" style="display: none">顯示錯誤</button>
        </div>
      </div>
    </div>
  </div>
</div>


</template>
<script>
import matcherModal from '../../elements/Modal.vue'
import $ from 'jquery'
import ImgUploadTemp from './Temp/ImgUploadTemp.vue'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import moment from 'moment'
import VueTimepicker from 'vue2-timepicker'
import { mapGetters } from 'vuex'
// import 'src/static/js/plugins/notify/notify.min.js'
import downloadFile from '../../../assets/js/down-load-file'
import ShippingForm from './Temp/ShippingForm'
import DatePicker from 'vue2-datepicker'
import DeliveryLimit from './Temp/DeliveryLimit.vue'
import 'vue2-datepicker/index.css'

export default {
  props: {
    'info': {
      type: Object
    }
  },
  data () {
    return {
      statusTypeList: [
        {label: '== 營業狀態 ==', value: 99},
        {label: '營業中', value: 2},
        {label: '籌備中', value: 1},
        {label: '尚未營業', value: 0},
        {label: '休息中', value: 3},
        {label: '已歇業', value: 9}
      ],
      form: {
        statusSelect: 99,
        orderStatusSelect: 99,
        isSearchSelect: 99
      },
      showCalendar: false,
      mealTagList: [],
      posBrief: [],
      storeName: '',
      storeDes: '',
      adRowNum: 2,
      groupList: [],
      areaTimes: 0,
      cityAreaList: [],
      areaOption: [],
      cityOption: [],
      imgLogoOption: [],
      imgBgOption: [],
      storeBrief: [],
      groupSelect: 0,
      imgLogoSelect: '',
      imgBgSelect: '',
      copyStoreSelect: null,
      copyBannerTypeList: null,
      areaSelect: 99,
      citySelect: 99,
      posSelect: null,
      posTypeSelect: 10,
      statusSelect: null,
      orderStatusSelect: null,
      isVisibleSelect: null,
      isStickerSelect: null,
      barcodeSelect: null,
      hasInvoicePaperSelect: null,
      hasInvoiceCarrierSelect: null,
      invoiceRemark: '',
      hasInvoiceNpobnaSelect: null,
      isInvoiceException: null,
      apiTypeSelect: null,
      showMenuIconSelect: null,
      plasticSelect: null,
      plasticAmountAdjustable: null,
      deliveryNeedSelect: null,
      isSearchSelect: null,
      roundingTypeSelect: null,
      couponFormSelect: null,
      showProdSettingSelect: null,
      isPosAccount: null,
      isCopy: null,
      img: {
        width: 0,
        height: 0
      },
      bgImg: {
        width: 0,
        height: 0
      },
      tradeInfo: [],
      tradeTypeOption: [
        {label: '現金付款', value: 1},
        {label: 'LINE Pay', value: 4},
        {label: '信用卡付款(TAPPAY)', value: 6},
        {label: '街口', value: 7},
        {label: '全盈+PAY', value: 8},
        {label: '台灣Pay', value: 10},
        {label: 'icash Pay', value: 11},
        {label: '全支付', value: 12},
        {label: '遠傳電信代收', value: 13},
        {label: '悠遊付', value: 14}
      ],
      takeTimeInfo: [
        {take_type: 1, prepare_time_seg: null, take_time_seg: null},
        {take_type: 2, prepare_time_seg: null, take_time_seg: null},
        {take_type: 3, prepare_time_seg: null, take_time_seg: null},
        {take_type: 4, prepare_time_seg: null, take_time_seg: null},
        {take_type: 5, prepare_time_seg: null, take_time_seg: null},
        {take_type: 21, prepare_time_seg: null, take_time_seg: null}
      ],
      openingInfo: [
        {week_day: 1, start: null, end: null},
        {week_day: 2, start: null, end: null},
        {week_day: 3, start: null, end: null},
        {week_day: 4, start: null, end: null},
        {week_day: 5, start: null, end: null},
        {week_day: 6, start: null, end: null},
        {week_day: 7, start: null, end: null}
      ],
      deliveryWaysInfo: [
        {take_type: 1, is_enable: null, is_support: null, is_default: null},
        {take_type: 2, is_enable: null, is_support: null, is_default: null},
        {take_type: 3, is_enable: null, is_support: null, is_default: null},
        {take_type: 4, is_enable: null, is_support: null, is_default: null},
        {take_type: 5, is_enable: null, is_support: null, is_default: null},
        {take_type: 21, is_enable: null, is_support: null, is_default: null}
      ],
      deliveryOther: [],
      storeInfo: {
        brand_name: '',
        branch_code: '',
        pos_branch_code: '',
        name: '',
        name_short: '',
        description: '',
        comment: '',
        ein: '',
        bl_name: '',
        address_short: '',
        tel: '',
        tel2: '',
        email: '',
        one_order_max_money: null,
        to_store_pay_max_money: null,
        order_start_time_m: null,
        order_end_time_m: null,
        auto_reject_order_m: null,
        image_name: '',
        bg_image_name: '',
        area_code: '',
        city_code: '',
        search_description: '',
        order_start_day: null,
        order_tolerance_day: null,
        auto_reject_order_reserve_m: null,
        plastic_unit: null,
        is_off_allow_order: null,
        is_preparing_allow_order: null,
        is_close_allow_order: null,
        show_menu_product_icon: null,
        menu_layout_type: null,
        menu_expand_type: null,
        max_delivery_distance_m: '',
        order_status_reason: null,
        menu_stop_sale_today_type: null,
        menu_stop_sale_type: null,
        menu_ab_block_type: null,
        photo_name: '',
        introduction: '',
        youtube_video_code: '',
        binding_meal_tag_ids: [],
        delivery_stage_limit_type: null,
        is_support_custom_remark: null,
        store_list: [],
        // 2023-04-24
        store_shipping_vendor: [
          {
            vendor_code: 'mete-mix',
            is_enable: null
          },
          {
            vendor_code: 'mete-pg',
            is_enable: null
          },
          {
            vendor_code: 'mete-ud',
            is_enable: null
          },
          {
            vendor_code: 'mete-lm',
            is_enable: null
          },
          {
            vendor_code: 'mete-glo',
            is_enable: null
          }
        ]
      },
      posAccount: {
        account: null,
        password: null
      },
      deliveryInfo: [
        {label: '自取', value: 1},
        {label: '內用', value: 2},
        {label: '外送', value: 3},
        {label: '內用-桌邊掃碼', value: 21}
      ],
      menuLayout: [
        {label: '文字，選項方塊 (飲料店用)', value: 1},
        {label: '圖文，商品描述為點擊後', value: 2},
        {label: '圖文，商品描述在下方', value: 3},
        {label: '圖文，商品描述在下方，外層大圖', value: 31},
        {label: '文字，選項條列式 (餐廳用)', value: 4}
      ],
      deliveryWayPlastic: null,
      offdaySetting: {
        date: [],
        weekDay: [],
        monthDay: [],
        options: {
          date: [
            {label: '無指定', value: 0}
          ],
          weekDay: [
            {label: '無指定', value: 0},
            {label: '週日', value: 1},
            {label: '週一', value: 2},
            {label: '週二', value: 3},
            {label: '週三', value: 4},
            {label: '週四', value: 5},
            {label: '週五', value: 6},
            {label: '週六', value: 7}
          ],
          month: [
            {label: '無指定', value: 0},
            {label: '一月', value: 1},
            {label: '二月', value: 2},
            {label: '三月', value: 3},
            {label: '四月', value: 4},
            {label: '五月', value: 5},
            {label: '六月', value: 6},
            {label: '七月', value: 7},
            {label: '八月', value: 8},
            {label: '九月', value: 9},
            {label: '十月', value: 10},
            {label: '十一月', value: 11},
            {label: '十二月', value: 12}
          ],
          monthDay: [
            {label: '無指定', value: 0}
          ]
        }
      },
      processTimeList: [],
      deliveryTypeOption: [
        {label: '所有', value: 0},
        {label: '自取', value: 1},
        {label: '內用', value: 2},
        {label: '外送', value: 3},
        // {label: '外帶', value: 4},
        // {label: '吧台', value: 5},
        {label: '內用-桌邊掃碼', value: 21}
      ],
      storeMethod: 1,
      printerStoreList: [],
      printerInfo: {
        identity: '',
        type: 1
      },
      printerSelect: 1,
      isPrinterSelect: '',
      printerList: [],
      delOption: {
        id: 'delModal',
        title: '刪除店家綁定',
        body: '確定刪除?<br>刪除此店家綁定！',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delBinding'
          }
        ]
      },
      updateOption: {
        id: 'updateModal',
        title: '提醒',
        body: '指定的設定值將立即覆蓋門市原設定，請再次確認是否執行。',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'updateBinding'
          }
        ]
      },
      selectChange: '',
      resetShopping: false, // 清空用
      editOption: {
        id: 'editModal',
        title: '編輯店家綁定',
        body: '編輯店家綁定！',
        input: {
          name: '綁定名稱'
        },
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'editBinding'
          }
        ]
      },
      selectOptions: {
        name: '綁定啟用',
        options: [
          {text: '啟用', value: 1},
          {text: '不啟用', value: 0}
        ]
      },
      current: {},
      change: {
        is_enabled: 1,
        binding_name: ''
      },
      tradeList: [],
      exceptionTradeList: [],
      exceptionCalendar: [],
      disModeSelect: null,
      reload: false,
      // 出單機layout
      printerLayoutList: [],
      printerLayoutSetting: [],
      selectDate: {
        'currentDate': '',
        'selectedDate': false,
        'selectedDateTime': false,
        'selectedHour': '00',
        'selectedMinute': '00',
        'selectedDatesItem': '',
        'selectedDates': [],
        'dateRange': { 'start': '', 'end': '' },
        'multipleDateRange': []
      },
      remarkMaxlength: 100,
      specialDayRemarkMaxlength: 15,
      tableNumberUrl: {
        text: '',
        type: 1
      },
      enterType: [], // 網址設定平台 options
      // 隱藏外帶(4) & 吧檯(5) 的取餐方式
      hideDeliveryType: [4, 5],
      // 桌邊掃碼 default
      tableNumber: {
        default_login_type: null,
        is_cash_pay_after_meal: null,
        is_table_no_editable: null,
        is_table_no_required: null,
        show_table_no: null,
        sub_delivery_type: null,
        type: 21
      },
      removeComment: null,
      includeStoresSetting: {
        class: 'include-class-store',
        options: [],
        choose: []
      },
      reNew: 0,
      reSet: 0,
      // 計費方式設定
      brandInvalidQuota: 0, // 品牌每月可作廢的訂單額度
      orderCommissionSetting: {
        has_independent_report: null, // 門市是否有獨立報表
        allow_invalid_order_quota: null, // 每月可作廢的訂單額度 (預設 2 筆)
        type: null, // 收費設定 (1:系統費 2:系統+資訊 3:資訊服務費抽成)
        item_list: [] // 資訊服務費細項設定
      },
      showOverlapErrorIndex: [], // 資訊服務費細項設定錯誤位置
      commissionItemList: { // 細項設定預設
        delivery_type: 0,
        start_time: null,
        end_time: null,
        ratio: null, // 抽成比例 (5=5%)
        rounding_type: 3 // 進位方式 (固定: 四捨五入)
      },
      supportDeliveryOption: [
        {label: '自取', value: 1},
        {label: '外送', value: 3}
      ],
      invalidStoreMap: null,
      showTablewareStrawOption: null, // 顯示購物車自選吸管或餐具功能(顯示)
      setTablewareStrawDefaultVal: null, // 預設吸管或餐具選項(關閉)
      showSpecialDayCalendar: false,
      selectSpecialDay: [], // 特殊日期表陣列
      tempSpecialDayCalendar: { // 特殊日期選擇器
        'currentDate': '',
        'selectedDate': false,
        'selectedDateTime': false,
        'selectedHour': '00',
        'selectedMinute': '00',
        'selectedDatesItem': '',
        'selectedDates': [],
        'dateRange': { 'start': '', 'end': '' },
        'multipleDateRange': []
      }
    }
  },
  methods: {
    getBrandInfo () {
      // 取得品牌每月可作廢的訂單額度
      const url = '/brand/' + this.$route.params.brand_id
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.brandInvalidQuota = response.data.brand_info.order_commission_setting.allow_invalid_order_quota
        }
      })
    },
    clearPage () {
      this.includeStoresSetting.option = null
      this.includeStoresSetting.choose = null
      if (this.storeMethod === 1) {
        this.removeComment = null
        this.storeInfo.comment = null
        this.storeInfo.binding_meal_tag_ids = null
        this.storeInfo.image_name = null
        this.storeInfo.photo_name = null
        this.storeInfo.bg_image_name = null
        this.storeInfo.introduction = null
        this.storeInfo.youtube_video_code = null
        this.storeInfo.food_business_no = null
        this.storeInfo.meat_origin_description = null
        this.storeInfo.description = null
        this.storeInfo.search_description = null
      } else if (this.storeMethod === 2) {
        this.apiTypeSelect = null
        this.statusSelect = null
        this.disModeSelect = null
        this.barcodeSelect = null
        this.roundingTypeSelect = null
        this.couponFormSelect = null
        this.showProdSettingSelect = null
        this.hasInvoicePaperSelect = null
        this.hasInvoiceCarrierSelect = null
        this.invoiceRemark = ''
        this.hasInvoiceNpobnaSelect = null
        this.isInvoiceException = null
        this.isVisibleSelect = null
        this.isSearchSelect = null
        this.isStickerSelect = null
        this.storeInfo.delivery_stage_limit_type = null
        this.storeInfo.is_support_custom_remark = null
        this.storeInfo.one_order_max_money = null
        this.storeInfo.to_store_pay_max_money = null
        this.storeInfo.menu_layout_type = null
        this.showMenuIconSelect = null
        this.storeInfo.show_menu_product_icon = null
        this.storeInfo.menu_expand_type = null
        this.storeInfo.menu_stop_sale_today_type = null
        this.storeInfo.menu_stop_sale_type = null
        this.storeInfo.menu_ab_block_type = null
        this.storeInfo.custom_sticker_max_length = null
      } else if (this.storeMethod === 3) {
        this.storeInfo.order_start_day = null
        this.storeInfo.order_tolerance_day = null
        this.storeInfo.auto_reject_order_reserve_m = null
        this.orderStatusSelect = null
        this.storeInfo.order_status_reason = null
        this.storeInfo.auto_reject_order_m = null
        this.storeInfo.is_preparing_allow_order = null
        this.storeInfo.is_close_allow_order = null
      } else if (this.storeMethod === 4) {
        this.tradeInfo = this.tradeInfo.map(x => {
          return {
            name: x.name,
            trade_type_id: x.trade_type_id,
            is_enable: null,
            is_support: null,
            remark: ''
          }
        })
        this.exceptionTradeList = []
        this.tableNumber.is_cash_pay_after_meal = null
      } else if (this.storeMethod === 5) {
        this.takeTimeInfo = this.takeTimeInfo.map(x => {
          return {
            take_type: x.take_type,
            prepare_time_seg: null,
            take_time_seg: null
          }
        })
        this.processTimeList = []
      } else if (this.storeMethod === 6) {
        this.deliveryWaysInfo = [
          {take_type: 1, is_enable: null, is_support: null, is_default: null},
          {take_type: 2, is_enable: null, is_support: null, is_default: null},
          {take_type: 3, is_enable: null, is_support: null, is_default: null},
          {take_type: 4, is_enable: null, is_support: null, is_default: null},
          {take_type: 5, is_enable: null, is_support: null, is_default: null},
          {take_type: 21, is_enable: null, is_support: null, is_default: null}
        ]
        this.deliveryOther = []
        this.tableNumber = {
          default_login_type: null,
          is_cash_pay_after_meal: null,
          is_table_no_editable: null,
          is_table_no_required: null,
          show_table_no: null,
          sub_delivery_type: null,
          type: 21
        }
        this.exceptionCalendar = []
        this.storeInfo.max_delivery_distance_m = null
        this.resetShopping = !this.resetShopping
      } else if (this.storeMethod === 7) {
        this.openingInfo = [
          {week_day: 1, start: null, end: null},
          {week_day: 2, start: null, end: null},
          {week_day: 3, start: null, end: null},
          {week_day: 4, start: null, end: null},
          {week_day: 5, start: null, end: null},
          {week_day: 6, start: null, end: null},
          {week_day: 7, start: null, end: null}
        ]
        this.storeInfo.is_off_allow_order = null
        this.selectDate = null
        this.selectSpecialDay = []
        this.offdaySetting.date = null
        this.offdaySetting.weekDay = null
        this.offdaySetting.monthDay = null
      } else if (this.storeMethod === 8) {
        this.storeInfo.plastic_unit = null
        this.plasticSelect = null
        this.deliveryWayPlastic = null
        this.plasticAmountAdjustable = null
      } else if (this.storeMethod === 12) {
        this.orderCommissionSetting = {
          has_independent_report: null, // 門市是否有獨立報表
          allow_invalid_order_quota: null, // 每月可作廢的訂單額度 (預設 2 筆)
          type: null, // 收費設定 (1:系統費 2:系統+資訊 3:資訊服務費抽成)
          item_list: [] // 資訊服務費細項設定
        }
      } else if (this.storeMethod === 13) {
        // 物流設定
        this.storeInfo.store_shipping_vendor.forEach(item => {
          item.is_enable = null
        })
      } else if (this.storeMethod === 15) {
        // 特殊需求
        this.showTablewareStrawOption = null
        this.setTablewareStrawDefaultVal = null
      }
    },
    calendarSelected (val) {
      // 驗證日期是否在允許的範圍內
      const selectedDate = moment(val.date, 'DD/MM/YYYY')
      const minDate = moment(this.calendarLimits.min, 'DD/MM/YYYY')
      const maxDate = moment(this.calendarLimits.max, 'DD/MM/YYYY')

      if (selectedDate.isBefore(minDate) || selectedDate.isAfter(maxDate)) {
        return
      }

      let formatDay = moment(val.date, 'D/M/YYYY').format('YYYY-MM-DD')
      if (!val.isMarked) {
        const oDate = {label: formatDay, value: formatDay}
        this.offdaySetting.date.push(oDate)
      } else {
        var index = this.offdaySetting.date.findIndex(e => e.value === formatDay)
        this.offdaySetting.date.splice(index, 1)
      }
    },
    specialDayCalendarSelected (rowIndex, val) {
      // 驗證日期是否在允許的範圍內
      const selectedDate = moment(val.date, 'DD/MM/YYYY')
      const minDate = moment(this.calendarLimits.min, 'DD/MM/YYYY')
      const maxDate = moment(this.calendarLimits.max, 'DD/MM/YYYY')

      if (selectedDate.isBefore(minDate) || selectedDate.isAfter(maxDate)) {
        return
      }

      let formatDay = moment(val.date, 'DD/MM/YYYY').format('YYYY-MM-DD')
      if (!val.isMarked) {
        const oDate = {label: formatDay, value: formatDay}
        this.selectSpecialDay[rowIndex].calendar_list.push(oDate)
      } else {
        var index = this.selectSpecialDay[rowIndex].calendar_list.findIndex(e => e.value === formatDay)
        if (index > -1) {
          this.selectSpecialDay[rowIndex].calendar_list.splice(index, 1)
        }
      }
      // 更新日曆顯示
      this.$nextTick(() => {
        const selectedDates = this.selectSpecialDay[rowIndex].calendar_list.map(item => {
          const date = moment(item.value, 'YYYY-MM-DD').format('D/M/YYYY')
          return { date: date, dateTime: false, hour: '00', minute: '00' }
        })
        this.tempSpecialDayCalendar.selectedDates = selectedDates.slice()
      })
    },
    removeTag (type, rowIndex, val) {
      let formatday = moment(val.value, 'YYYY-MM-DD').format('D/M/YYYY')

      if (type === 'date') {
        if (this.selectDate.selectedDates) {
          var index = this.selectDate.selectedDates.findIndex(e => e.date === formatday)
          if (index > -1) {
            this.selectDate.selectedDates.splice(index, 1)
          }
        }
      } else if (type === 'specialDay') {
        let index = this.selectSpecialDay[rowIndex].calendar_list.findIndex(e => e.value === val.value)
        if (index > -1) {
          this.selectSpecialDay[rowIndex].calendar_list.splice(index, 1)
        }
      }
    },
    openSpecialDayCalendar (rowIndex) {
      // 依 calendar_list 更新日曆
      const selectedDates = this.selectSpecialDay[rowIndex].calendar_list.map(item => {
        return { date: moment(item.value, 'YYYY-MM-DD').format('D/M/YYYY'), dateTime: false, hour: '00', minute: '00' }
      })
      this.tempSpecialDayCalendar.selectedDates = selectedDates.slice()
      this.selectSpecialDay[rowIndex].showSpecialDayCalendar = true
      this.removeMultiselectWrapper()
    },
    openDateCalendar () {
      this.showCalendar = true
      this.removeMultiselectWrapper()
    },
    removeMultiselectWrapper () {
      this.$nextTick(() => {
        // 只刪除 calendar-multiselect 相關的 wrapper
        const calendarMultiselects = document.querySelectorAll('.calendar-multiselect')
        calendarMultiselects.forEach(multiselect => {
          const wrappers = multiselect.querySelector('.multiselect__content-wrapper')
          wrappers.forEach(wrapper => {
            wrapper.remove()
          })
        })
      })
    },
    setReload (tradeType) {
      if (tradeType.meta) tradeType.meta.delete_key = 1
      if (tradeType.custom_config) tradeType.custom_config.delete_key = 1
      this.reload = true
    },
    removeListItem (list, index) {
      list.splice(index, 1)
    },
    validateTimeRange (item, startTimeKey = 'start_time', endTimeKey = 'end_time') {
      // 從 item 中取得對應的時間欄位
      const startTime = item[startTimeKey]
      const endTime = item[endTimeKey]
      // 若任何一個為空值，就先不驗證
      if (!startTime || !endTime) {
        return true
      }

      const startTimeTrimmed = startTime.trim()
      const endTimeTrimmed = endTime.trim()

      const startMoment = moment(startTimeTrimmed, 'HH:mm', true)
      const endMoment = moment(endTimeTrimmed, 'HH:mm', true)

      // 打烊時間需 > 營業時間
      if (startMoment.isSameOrAfter(endMoment)) {
        this.$notify({
          title: '提醒',
          text: '結束時間必須晚於開始時間',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        item[endTimeKey] = ''
        return false
      }
      return true
    },
    clearProcess (process) {
      process.end_value = ''
      process.start_value = ''
    },
    addItemTime (process) {
      var item = {
        start_time: '',
        end_time: '',
        process_time: ''
      }
      process.item_list.push(item)
    },
    addProcessTime () {
      var process = {
        month: 0,
        value_type: 1,
        start_value: '',
        end_value: '',
        delivery_type: 1,
        item_list: [
          {
            start_time: '',
            end_time: '',
            process_time: ''
          }
        ]
      }
      this.processTimeList.push(process)
    },
    addExCalendar () {
      var calendar = {
        delivery_type: 1,
        date_type: [],
        week_day: [],
        month_day: []
      }
      this.exceptionCalendar.push(calendar)
    },
    addExDate (exCalendar) {
      var date = {
        date: '',
        start_time: '',
        end_time: ''
      }
      exCalendar.date_type.push(date)
    },
    addExWeekDay (exCalendar) {
      var weekDay = {
        day: 1,
        start_time: '',
        end_time: ''
      }
      exCalendar.week_day.push(weekDay)
    },
    addExMonthDay (exCalendar) {
      var monthDay = {
        day: '',
        start_time: '',
        end_time: ''
      }
      exCalendar.month_day.push(monthDay)
    },
    addStartMonthDayTag (newTag, id) {
      const tag = {
        label: newTag,
        value: newTag
      }
      this.offdaySetting.options.monthDay.push(tag)
      // this.offdaySetting.monthDay.push(tag)
    },
    addEndMonthDayTag (newTag, id) {
      const tag = {
        label: newTag,
        value: newTag
      }
      this.offdaySetting.options.monthDay.push(tag)
      // this.offdaySetting.monthDay.push(tag)
    },
    addDateTag (newTag) {
      const tag = {
        label: newTag,
        value: newTag
      }
      this.offdaySetting.options.date.push(tag)
      // this.offdaySetting.date.push(tag)
    },
    addMonthDayTag (newTag) {
      const tag = {
        label: newTag,
        value: newTag
      }
      this.offdaySetting.options.monthDay.push(tag)
      // this.offdaySetting.monthDay.push(tag)
    },
    addSpecialDay () {
      var calendar = {
        showSpecialDayCalendar: false,
        calendar_list: [],
        start_time: '',
        end_time: '',
        remark: ''
      }
      this.selectSpecialDay.push(calendar)
    },
    returnNum (e) {
      var charCode = (e.which) ? e.which : e.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        e.preventDefault()
      } else {
        return true
      }
    },
    getMealTagList (callback) {
      var self = this
      var url = '/mealTag/listBrief?is_visible=1'
      self.mealTagList = []
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          response.data.list.forEach(function (tag) {
            const obj = {
              label: tag.name,
              value: tag.tag_id
            }
            self.mealTagList.push(obj)
          })
          callback()
        }
      })
    },
    init () {
      const self = this
      this.getMealTagList(function () {
        self.getTradeTypeList()
      })
      this.getCityAreaList()
      if (this.getRoleType === 99 || this.getRoleType === 30) this.getBrandImgList()
      else this.storeMethod = 3
      this.getStoreBrief()
      this.getBrandInfo()
      this.getShippingVendorList()
    },
    addAdRow () {
      this.adRowNum = this.adRowNum + 1
    },
    delAdRow () {
      this.adRowNum = this.adRowNum - 1
    },
    getGroupList () {
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/storeGroupListBrief'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.groupList = response.data.list
          if (self.groupList.length) self.groupSelect = self.groupList[0].id
        }
      })
    },
    getPrinterLayoutList () {
      var self = this
      var url = '/platform/printerLayoutList'
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.printerLayoutList = response.data.list
          self.printerLayoutList.forEach(function (layout) {
            const obj = {
              trigger_type: 1,
              layout_type: layout.layout_type,
              layout_name: layout.name,
              is_enabled: 1
            }
            if (layout.is_enabled) {
              self.printerLayoutSetting.push(obj)
            }
          })
        }
      })
    },
    getTradeTypeList () {
      var self = this
      var url = '/platform/tradeTypeList'
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.tradeInfo = []
          var list = response.data.list
          for (var i = 0; i < list.length; i++) {
            if (list[i].is_valid) {
              var option = {
                name: list[i].name,
                trade_type_id: parseInt(list[i].id, 10),
                is_enable: null,
                is_support: null,
                remark: ''
              }
              if (i === 0) option.is_enable = null
              if (list[i].meta !== null) {
                option.meta = {
                  use_key: 0,
                  key: {}
                }
                list[i].meta.keys.forEach(function (key) {
                  option.meta.key[key] = ''
                })
              }
              if (list[i].custom_config !== null) {
                option.custom_config = {
                  use_key: 0,
                  key: {}
                }
                list[i].custom_config.keys.forEach(function (key) {
                  option.custom_config.key[key] = ''
                })
              }
              self.tradeInfo.push(option)
              var option2 = {
                label: list[i].name,
                value: parseInt(list[i].type, 10)
              }
              self.tradeList.push(option2)
            }
          }
        }
        if (self.$route.name !== 'upStore') self.getPrinterLayoutList()
      })
    },
    getCityAreaList () {
      var self = this
      var url = '/platform/cityAreaList'
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.cityAreaList = response.data.list
          for (var i = 0; i < self.cityAreaList.length; i++) {
            var option = {name: self.cityAreaList[i].name, value: self.cityAreaList[i].city_code}
            self.cityOption.push(option)
            if (i === 0) self.citySelect = self.cityAreaList[i].city_code
          }
          // self.groupList = response.data.list
        }
      })
    },
    getShippingVendorList () {
      // 取得目前可設定物流廠商
      const url = '/platform/shippingVendorList?type=2&is_visable=1'
      this.getData('get', url, null, (response) => {
        if (response.data.status === 200) {
          const visibleList = response.data.list.map(item => {
            return item.vendor_code
          })
          this.storeInfo.store_shipping_vendor = this.storeInfo.store_shipping_vendor.filter(item => {
            return visibleList.includes(item.vendor_code)
          })
        }
      })
    },
    checkDefault (type) {
      // 先清除不正確的取貨方式的預設狀態
      this.deliveryWaysInfo.forEach(item => {
        if (item.take_type !== type) {
          item.is_default = 0
        }
      })

      // 將正確的取貨方式設為預設
      const selectedDelivery = this.deliveryWaysInfo.find(item => item.take_type === type)
      if (selectedDelivery) {
        selectedDelivery.is_default = 1
      }

      // 在選擇後觸發畫面更新
      this.$forceUpdate()
    },
    checkOtherDelivery () {
      for (var i = 0; i < this.deliveryOther.length; i++) {
        if (i === 0) {
          this.deliveryOther[i].price = this.deliveryWaysInfo[2].price
        }
      }
    },
    checkDelivery () {
      for (var i = 0; i < this.deliveryOther.length; i++) {
        if (i === 0) {
          this.deliveryWaysInfo[2].price = this.deliveryOther[i].price
        }
      }
    },
    getWeekDayName (weekDay) {
      if (weekDay === 1) return '星期日'
      else if (weekDay === 2) return '星期一'
      else if (weekDay === 3) return '星期二'
      else if (weekDay === 4) return '星期三'
      else if (weekDay === 5) return '星期四'
      else if (weekDay === 6) return '星期五'
      else if (weekDay === 7) return '星期六'
    },
    onPhotoFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      let imgName = files[0].name.split('.')
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        // $('#file-upload').replaceWith($('#file-upload').val(''))
      } else {
        this.createImage(files[0], 4) // 底圖照片
      }
    },
    onFileChange (e) {
      this.imgLogoSelect = ''
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      let imgName = files[0].name.split('.')
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        // $('#file-upload').replaceWith($('#file-upload').val(''))
      } else {
        this.createImage(files[0], 1)
      }
    },
    createImage (file, method) {
      var reader = new FileReader()
      var self = this
      reader.onload = (e) => {
        var img = new Image()
        img.src = e.target.result
        if (method === 1) {
          self.storeInfo.image = img.src
          self.storeInfo.image_name = img.src
        } else if (method === 4) self.storeInfo.photo_name = img.src
        img.onload = () => {
          self.img.width = img.width
          self.img.height = img.height
          self.checkImgSize(null, method)
        }
      }
      reader.readAsDataURL(file)
    },
    checkImgSize (type, method) {
      var self = this
      if ((this.img.width !== 200 || this.img.height !== 200) && this.img.width !== 0 && this.img.height !== 0 && method === 1) {
        this.$notify({
          title: '提醒',
          text: 'LOGO尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳200x200之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if ((this.img.width !== 800 || this.img.height !== 460) && this.img.width !== 0 && this.img.height !== 0 && method === 3) {
        this.$notify({
          title: '提醒',
          text: '底圖照片寸為' + self.img.width + 'x' + self.img.height + '，請上傳800x460之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (type === 'cr') {
        // this.createdBrand()
      } else if (type === 'up') {
        // if ($('#brand-img-load')[0].files[0]) this.updatedIcon()
        // else this.updatedBrand()
      }
    },
    onBgChange (e) {
      this.imgBgSelect = ''
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      let imgName = files[0].name.split('.')
      let imgSize = Math.round(files[0].size / 1000)
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        // $('#file-upload').replaceWith($('#file-upload').val(''))
      } else if (imgSize > 1024) {
        this.$notify({
          title: '提醒',
          text: '圖片檔案為' + imgSize + 'KB，請上傳小於1024KB之圖片',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        // this.createBgImage(files[0])
      }
    },
    createBgImage (file) {
      var reader = new FileReader()
      var self = this
      reader.onload = (e) => {
        var img = new Image()
        img.src = e.target.result
        if (self.storeInfo.bg_image) self.storeInfo.bg_image = img.src
        self.storeInfo.bg_image_name = img.src
        img.onload = () => {
          self.bgImg.width = img.width
          self.bgImg.height = img.height
          self.checkBgImgSize()
        }
      }
      reader.readAsDataURL(file)
    },
    checkBgImgSize (type) {
      var self = this
      if ((this.bgImg.width !== 625 || this.bgImg.height !== 300) && this.bgImg.width !== 0 && this.bgImg.height !== 0) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.bgImg.width + 'x' + self.bgImg.height + '，請上傳625x300之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (type === 'cr') {
        // this.createdBrand()
      } else if (type === 'up') {
        // if ($('#brand-img-load')[0].files[0]) this.updatedIcon()
        // else this.updatedBrand()
      }
    },
    getPosBrief () {
      this.posBrief = []
      var self = this
      var url = '/pos/vendorBriefList'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var pList = response.data.list
          for (let i = 0; i < pList.length; i++) {
            let obj = {label: pList[i].name, value: pList[i].pos_vendor_id}
            self.posBrief.push(obj)
            if (i === pList.length - 1) {
              self.posSelect = pList[i].pos_vendor_id
            }
          }
        }
      })
    },
    getStoreBrief () {
      this.includeStoresSetting.options = []
      this.includeStoresSetting.choose = []
      this.storeBrief = []
      var self = this

      var url = '/brand/' + this.$route.params.brand_id + '/storeListBrief?list_sort=name ASC'
      if (this.form.statusSelect !== 99) {
        url += '&status=' + this.form.statusSelect.toString()
      }
      if (this.form.orderStatusSelect !== 99) {
        url += '&order_status=' + this.form.orderStatusSelect.toString()
      }
      if (this.form.isSearchSelect !== 99) {
        url += '&is_search=' + this.form.isSearchSelect.toString()
      }
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          if (self.getRoleType === 99 && self.info) self.getPrinterStoreList()
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.includeStoresSetting.options.push(obj)
            if (i === 0) self.copyStoreSelect = sList[i].store_id
          }
        }
        this.reNew++
      })
    },
    verityTel () {
      var e = $(this.$refs.tel)
      this.storeInfo.tel = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9-#()\s]*/))
      }
    },
    verityTel2 () {
      var e = $(this.$refs.tel2)
      this.storeInfo.tel2 = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9-#()\s]*/))
      }
    },
    verityEin () {
      var e = $(this.$refs.ein)
      this.storeInfo.ein = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityOneOrderMaxMoney () {
      var e = $(this.$refs.oneOrderMaxMoney)
      this.storeInfo.one_order_max_money = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityStorePayMaxMoney () {
      var e = $(this.$refs.storePayMaxMoney)
      this.storeInfo.to_store_pay_max_money = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityRejectTime () {
      var e = $(this.$refs.rejectTime)
      this.storeInfo.auto_reject_order_m = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityStartTime () {
      var e = $(this.$refs.startTime)
      this.storeInfo.order_start_time_m = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityEndTime () {
      var e = $(this.$refs.endTime)
      this.storeInfo.order_end_time_m = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    getToast (msg, type) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        if (type === 'cr') this.createdStore()
        else if (type === 'up' && this.storeMethod === 1 && this.getRoleType !== 10) this.updatedLogoImg()
        else if (type === 'up') this.updatedStore()
      }
    },
    getBrandImgList () {
      var self = this
      var url = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=1'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var logoList = response.data.list
          for (var i = 0; i < logoList.length; i++) {
            var option = {name: logoList[i].image_name, value: logoList[i].image_url}
            self.imgLogoOption.push(option)
          }
        }
      })
      var url2 = '/brand/' + this.$route.params.brand_id + '/storesImage?image_type=3'
      this.getDataH('get', url2, null, function (response) {
        if (response.data.status === 200) {
          var bgList = response.data.list
          for (var j = 0; j < bgList.length; j++) {
            var option2 = {name: bgList[j].image_name, value: bgList[j].image_url}
            self.imgBgOption.push(option2)
          }
        }
      })
    },
    dateRangeOverlaps (startA, endA, startB, endB) {
      // 判斷時間是否重複
      if (startA === endA && startB === endB) {
        return startA === startB
      } else if (startA === endA && startB !== endB) {
        return startA >= startB && startA <= endB
      } else if (startA !== endA && startB === endB) {
        return startB >= startA && startB <= endA
      } else {
        return (startA <= endB && startB < endA)
      }
    },
    async updatedLogoImg () {
      var data = new FormData()
      // icon 圖片
      if (this.imgLogoSelect) {
        data.append('image_name', this.imgLogoSelect)
        await this.upImg(data, 1)
      } else if ($('#brand-img-load')[0].files[0]) {
        data.append('image_file', $('#brand-img-load')[0].files[0])
        var imgPath = $('#brand-img-load')[0].files[0]
        var imgName = imgPath.name.replace(/\.(jpg|gif|png)$/, '')
        data.append('image_name', imgName)
        await this.upImg(data, 1)
      }
      if (this.getRoleType !== 10) {
        if ($('#brand-photo-load')[0].files[0]) {
          data.append('image_file', $('#brand-photo-load')[0].files[0])
          var imgPath2 = $('#brand-photo-load')[0].files[0]
          var imgName2 = imgPath2.name.replace(/\.(jpg|gif|png)$/, '')
          data.append('image_name', imgName2)
          await this.upImg(data, 4)
        }
      }
    },
    checkCommission () {
      // 計費方式欄位防呆
      const itemList = this.orderCommissionSetting.item_list
      if (this.orderCommissionSetting.allow_invalid_order_quota === '') {
        return '請輸入每月作廢訂單額度(筆)'
      } else if (this.orderCommissionSetting.type > 1) {
        if (!itemList.length) {
          return '請增加資訊服務費抽成設定'
        } else {
          // 判斷抽成詳細設定
          this.showOverlapErrorIndex = []
          for (let i = 0; i < itemList.length; i++) {
            const startTime = itemList[i].start_time
            const endTime = itemList[i].end_time
            if (itemList[i].ratio === '') {
              this.showOverlapErrorIndex = [i]
              return '請輸入資訊服務費抽成%'
            } else if (!startTime || !endTime) {
              this.showOverlapErrorIndex = [i]
              return `請輸入抽成${!startTime ? '生效' : '結束'}時間`
            } else if (moment(endTime).isBefore(startTime)) {
              this.showOverlapErrorIndex = [i]
              return '結束時間小於開始時間，請重新選擇!'
            } else if (i > 0) {
              // 若目前設定的取餐方式與之前的相同或包含，則比對時間是否有重複
              for (let j = (i - 1); j >= 0; j--) {
                // delivery_type = 0 為全部
                if (itemList[i].delivery_type === 0 || itemList[j].delivery_type === 0 || itemList[i].delivery_type === itemList[j].delivery_type) {
                  const lastStartTime = itemList[j].start_time
                  const lastEndTime = itemList[j].end_time
                  if (this.dateRangeOverlaps(startTime, endTime, lastStartTime, lastEndTime)) {
                    this.showOverlapErrorIndex.push(j)
                    this.showOverlapErrorIndex.push(i)
                  }
                }
              }
            }
          }
          if (this.showOverlapErrorIndex.length) {
            return `時間重覆設定，請確認!`
          }
        }
      }
      return false
    },
    upImg (data, type) {
      var self = this
      data.append('image_type', type)
      if (this.includeStoresSetting.choose.length) {
        data.append('store_list', this.includeStoresSetting.choose.toString())
      }
      var url = '/brand/' + this.$route.params.brand_id + '/storesImage'
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            })
          }
        })
      }
    },
    updatedBgImg () {
      var self = this
      var data = new FormData()
      //  圖片
      if (self.imgBgSelect) {
        data.append('image_name', self.imgBgSelect)
        self.upImg(data, 3)
      } else if ($('#bg-img-load')[0].files[0]) {
        data.append('image_file', $('#bg-img-load')[0].files[0])
        var bgPath = $('#bg-img-load')[0].files[0]
        var bgName = bgPath.name.replace(/\.(jpg|gif|png)$/, '')
        data.append('bg_image_name', bgName)
        self.upImg(data, 3)
      } else if (self.getRoleType === 99) self.updatedStore()
    },
    async updatedStore (isChecked = false) {
      if (this.storeMethod === 1 && (this.getRoleType === 99 || this.getRoleType === 30)) {
        await this.updatedLogoImg()
      }
      if (this.storeMethod === 9) {
        this.$refs.shipping.checkShipping()
        return
      }
      var self = this
      var sInfo = this.storeInfo
      var oneOrderMaxMoney = sInfo.one_order_max_money ? parseInt(sInfo.one_order_max_money, 10) : null
      var toStorePayMaxMoney = sInfo.to_store_pay_max_money ? parseInt(sInfo.to_store_pay_max_money, 10) : null
      var orderStartTimeM = sInfo.order_start_time_m ? parseInt(sInfo.order_start_time_m, 10) : null
      var orderEndTimeM = sInfo.order_end_time_m ? parseInt(sInfo.order_end_time_m, 10) : null
      var autoRejectOrderM = sInfo.auto_reject_order_m ? parseInt(sInfo.auto_reject_order_m, 10) : null
      var orderStartDay = sInfo.order_start_day ? parseInt(sInfo.order_start_day, 10) : null
      var orderToleranceDay = sInfo.order_tolerance_day ? parseInt(sInfo.order_tolerance_day, 10) : null
      var autoRejectOrderReserveM = sInfo.auto_reject_order_reserve_m ? parseInt(sInfo.auto_reject_order_reserve_m, 10) : null
      var method = this.storeMethod
      var data = {}
      if (method === 1) {
        data = {}
        var comment = sInfo.comment
        if (sInfo.comment) data.comment = comment
        const ids = sInfo.binding_meal_tag_ids.map(item => item.value)
        if (ids.length) data.binding_meal_tag_ids = ids
        if (sInfo.youtube_video_code) data.youtube_video_code = sInfo.youtube_video_code

        // 肉品產地說明
        if (sInfo.meat_origin_description) data.meat_origin_description = sInfo.meat_origin_description

        data.description = sInfo.description
        data.search_description = sInfo.search_description
        data.introduction = sInfo.introduction
      } else if (method === 2) {
        data = {
          api_type: this.apiTypeSelect,
          status: this.statusSelect,
          is_visible: this.isVisibleSelect,
          barcode_type: this.barcodeSelect,
          one_order_max_money: oneOrderMaxMoney,
          to_store_pay_max_money: toStorePayMaxMoney,
          has_invoice_paper: this.hasInvoicePaperSelect,
          has_invoice_carrier: this.hasInvoiceCarrierSelect,
          invoice_remark: this.invoiceRemark,
          has_invoice_npoban: this.hasInvoiceNpobnaSelect,
          is_invoice_exception: this.isInvoiceException,
          show_menu_icon: this.showMenuIconSelect,
          show_menu_product_icon: sInfo.show_menu_product_icon,
          menu_layout_type: sInfo.menu_layout_type,
          rounding_type: self.roundingTypeSelect,
          coupon_form: self.couponFormSelect,
          menu_expand_type: sInfo.menu_expand_type,
          is_search: self.isSearchSelect,
          menu_ab_block_type: sInfo.menu_ab_block_type, // 紅配綠菜單分類顯示
          // 2019-06-12 新增
          menu_stop_sale_type: sInfo.menu_stop_sale_type,
          // 2023-11-22
          menu_stop_sale_today_type: sInfo.menu_stop_sale_today_type,
          // 2019-07-18 新增
          distance_service_model: self.disModeSelect,
          is_support_custom_sticker: self.isStickerSelect,
          // 2020-04-28 新增
          delivery_stage_limit_type: sInfo.delivery_stage_limit_type,
          // 2020-04-28 新增
          show_product_setting: self.showProdSettingSelect,
          is_support_custom_remark: sInfo.is_support_custom_remark,
          custom_sticker_max_length: sInfo.custom_sticker_max_length
        }
      } else if (method === 3) {
        data = {
          order_status: this.orderStatusSelect,
          order_start_time_m: orderStartTimeM,
          order_end_time_m: orderEndTimeM,
          auto_reject_order_m: autoRejectOrderM,
          order_start_day: orderStartDay,
          order_tolerance_day: orderToleranceDay,
          auto_reject_order_reserve_m: autoRejectOrderReserveM,
          is_preparing_allow_order: sInfo.is_preparing_allow_order,
          is_close_allow_order: sInfo.is_close_allow_order,
          order_status_reason: sInfo.order_status_reason
        }
      } else if (method === 4) {
        // 店家付款方式
        let tradeInfo = []
        for (let l = 0; l < this.tradeInfo.length; l++) {
          let option4 = {
            trade_type_id: this.tradeInfo[l].trade_type_id || null,
            is_enable: this.tradeInfo[l].is_enable || null,
            is_support: this.tradeInfo[l].is_support || null,
            remark: this.tradeInfo[l].remark || null
          }
          option4 = this.setData(option4)
          if (Object.values(option4).length > 1) {
            tradeInfo.push(option4)
          }
        }
        if (tradeInfo.length > 0) {
          data.trade_types = JSON.stringify(tradeInfo)
        }
        // 現金付款設定
        if (this.tableNumber.is_cash_pay_after_meal !== null) {
          let customConfig = data.delivery_way_custom_config || []
          customConfig.push({
            type: 21,
            config: {
              is_cash_pay_after_meal: this.tableNumber.is_cash_pay_after_meal
            }
          })
          data.delivery_way_custom_config = JSON.stringify(customConfig)
        }
        // 付款方式與取餐金額
        var newETradeList = []
        this.exceptionTradeList.forEach(function (eTrade) {
          var obj = eTrade
          if (!obj.start_money) obj.start_money = null
          if (!obj.end_money) obj.end_money = null
          newETradeList.push(obj)
        })
        if (newETradeList.length) {
          data.delivery_exception_trade_setting = newETradeList
        }
      } else if (method === 5) {
        // 更改某時段製作時間
        var newTimeList = []
        this.processTimeList.forEach(function (item) {
          var process = {
            month: item.month.value,
            value_type: item.value_type,
            start_value: item.start_value.value,
            end_value: item.end_value.value,
            delivery_type: item.delivery_type.value,
            item_list: item.item_list
          }
          newTimeList.push(process)
        })
        if (newTimeList.length) data['process_time_setting'] = JSON.stringify(newTimeList)
        // 店家製作與取餐時間
        let takeTimeInfo = []
        for (let k = 0; k < this.takeTimeInfo.length; k++) {
          if (this.takeTimeInfo[k].prepare_time_seg === '') {
            // 判斷是否被使用者清空
            this.takeTimeInfo[k].prepare_time_seg = null
          }
          if (this.takeTimeInfo[k].take_time_seg === '') {
            // 判斷是否被使用者清空
            this.takeTimeInfo[k].take_time_seg = null
          }
          if (this.takeTimeInfo[k].prepare_time_seg !== null || this.takeTimeInfo[k].take_time_seg !== null) {
            if (this.takeTimeInfo[k].prepare_time_seg < 3) {
              this.$notify({
                title: '提醒',
                text: '準備時間不可低於 3 分鐘',
                duration: 3000,
                type: 'danger',
                width: 400
              })
              return false
            }
            let option3 = {
              take_type: parseInt(this.takeTimeInfo[k].take_type, 10)
            }
            if (this.takeTimeInfo[k].prepare_time_seg !== null) {
              option3.prepare_time_seg = parseInt(this.takeTimeInfo[k].prepare_time_seg, 10)
            }
            if (this.takeTimeInfo[k].take_time_seg !== null) {
              option3.take_time_seg = parseInt(this.takeTimeInfo[k].take_time_seg, 10)
            }
            takeTimeInfo.push(option3)
          }
        }
        if (takeTimeInfo.length) {
          data.take_time_seg = JSON.stringify(takeTimeInfo)
        }
      } else if (method === 6) {
        // 店家取餐方式與門檻
        let deliveryWays = []
        let memoList = []

        // 更新運費設定
        let shippingComponent = this.$refs.shippingInfo
        if (shippingComponent) {
          if (shippingComponent.feeTypeSelect !== 1 && sInfo.max_delivery_distance_m) {
            let overLimit = shippingComponent.itemList.some(item => item.distance > sInfo.max_delivery_distance_m)
            if (overLimit) {
              this.$notify({
                title: '提醒',
                text: '運送距離不可超過最遠可外送距離！',
                duration: 3000,
                type: 'danger',
                width: 400
              })
              return
            }
          }
          let shippingSetSuccess = false
          await shippingComponent.upShippingFee()
            .then((res) => {
              shippingSetSuccess = true
            })
            .catch((res) => {
              shippingSetSuccess = false
            })
          if (!shippingSetSuccess) return
        }

        for (let k = 0; k < this.deliveryWaysInfo.length; k++) {
          if (Object.values(this.deliveryWaysInfo[k]).filter(x => x !== null).length > 1) {
            let option = {
              distance_m: this.deliveryWaysInfo[k].distance_m,
              is_allow_guest_order: this.deliveryWaysInfo[k].is_allow_guest_order,
              is_default: this.deliveryWaysInfo[k].is_default,
              is_enable: this.deliveryWaysInfo[k].is_enable,
              is_support: this.deliveryWaysInfo[k].is_support,
              option: 1,
              price: this.deliveryWaysInfo[k].price || null,
              take_type: this.deliveryWaysInfo[k].take_type
            }
            if (option.distance_m || option.is_allow_guest_order || option.is_default || option.is_enable !== null || option.is_support !== null || option.price) {
              deliveryWays.push(option)
            }
            if (option.price) {
              option.distance_m = 0
            }

            const memoItem = { take_type: this.deliveryWaysInfo[k].take_type }
            if (this.deliveryWaysInfo[k].memo) memoItem.memo = this.deliveryWaysInfo[k].memo
            if (this.deliveryWaysInfo[k].pickup_memo) memoItem.pickup_memo = this.deliveryWaysInfo[k].pickup_memo
            memoList.push(memoItem)
          }
        }
        if (memoList.length) {
          data.delivery_way_memo = JSON.stringify(memoList)
        }
        for (let j = 0; j < this.deliveryOther.length; j++) {
          let option2 = {
            take_type: this.deliveryOther[j].take_type,
            is_support: this.deliveryOther[j].is_support,
            is_enable: this.deliveryOther[j].is_enable,
            distance_m: this.deliveryOther[j].distance_m || null,
            price: this.deliveryOther[j].price || null,
            option: 2,
            is_allow_guest_order: this.deliveryOther[j].is_allow_guest_order
          }
          if (!this.deliveryOther[j].distance_m || !this.deliveryOther[j].price) {
            this.$notify({
              title: '提醒',
              text: '請輸入完整的外送條件',
              duration: 3000,
              type: 'danger',
              width: 400
            })
            return false
          }
          if (this.deliveryOther[j].distance_m && (this.deliveryOther[j].price || j === 0)) {
            deliveryWays.push(option2)
          }
        }
        if (deliveryWays.filter(x => x.take_type === 3 && x.option === 2).length > 0 && deliveryWays.filter(x => x.take_type === 3 && x.option === 1).length < 1) {
          this.$notify({
            title: '提醒',
            text: '請輸入正確的最低門檻',
            duration: 3000,
            type: 'danger',
            width: 400
          })
          return false
        }
        if (deliveryWays.filter(x => x.take_type === 3 && x.option === 1 && x.price).length > 0 && !sInfo.max_delivery_distance_m) {
          this.$notify({
            title: '提醒',
            text: '請輸入正確的最遠可送',
            duration: 3000,
            type: 'danger',
            width: 400
          })
          return false
        }
        if (deliveryWays.length > 0) {
          data.delivery_ways = JSON.stringify(deliveryWays)
        }
        // 外送最大距離
        if (sInfo.max_delivery_distance_m) data.max_delivery_distance_m = sInfo.max_delivery_distance_m
        else data.max_delivery_distance_m = null
        // 桌號設定
        let customConfig = data.delivery_way_custom_config || []
        customConfig.push({
          type: 21,
          config: {
            default_login_type: this.tableNumber.default_login_type,
            is_table_no_editable: this.tableNumber.is_table_no_editable,
            is_table_no_required: this.tableNumber.is_table_no_required,
            show_table_no: this.tableNumber.show_table_no,
            sub_delivery_type: this.tableNumber.sub_delivery_type
          }
        })
        customConfig[0].config = this.setData(customConfig[0].config)
        if (Object.values(customConfig[0].config).length > 0) {
          data.delivery_way_custom_config = JSON.stringify(customConfig)
        }
        var newECalendarList = {}
        this.exceptionCalendar.forEach(function (eCalendar) {
          var obj = {
            date_type: eCalendar.date_type,
            week_day: eCalendar.week_day,
            month_day: eCalendar.month_day
          }
          if (Object.values(obj).length) {
            newECalendarList[eCalendar.delivery_type] = obj
          }
        })
        if (this.exceptionCalendar.length) {
          data.delivery_exception_calendar_setting = newECalendarList
        }
      } else if (method === 7) {
        data = {
          is_off_allow_order: sInfo.is_off_allow_order
        }
        // 店家營業時間
        let openingTimes = []
        for (let i = 0; i < this.openingInfo.length; i++) {
          const obj = this.openingInfo[i]
          if (obj.start || obj.end) {
            let openTime = {
              week_day: obj.week_day,
              start_time: obj.start + ':00',
              end_time: obj.end + ':59'
            }
            openingTimes.push(openTime)
          }
        }
        if (openingTimes.length) {
          data.opening_times = JSON.stringify(openingTimes)
        }
        // 營業時間 - 特殊日期
        if (this.selectSpecialDay.length > 0) {
          let specialTimes = []
          this.selectSpecialDay.forEach(item => {
            const obj = {
              calendar_list: item.calendar_list.map(date => ({usage_type: 1, usage_date: date.value})),
              start_time: item.start_time + ':00',
              end_time: item.end_time + ':59',
              remark: item.remark
            }
            specialTimes.push(obj)
          })
          data.order_time_setting = JSON.stringify(specialTimes)
        } else {
          data.order_time_setting = ''
        }
        // 公休
        let offday = {}
        if (this.offdaySetting.date.length) {
          offday['date'] = this.offdaySetting.date.map(x => x.value)
        }
        if (this.offdaySetting.weekDay.length) {
          offday['week_day'] = this.offdaySetting.weekDay.map(x => x.value)
        }
        if (this.offdaySetting.monthDay.length) {
          offday['month_day'] = this.offdaySetting.monthDay.map(x => x.value)
        }
        if (Object.keys(offday).length) {
          data['offday_setting'] = offday
        }
      } else if (method === 8) {
        data = {
          plastic_unit: this.storeInfo.plastic_unit ? parseInt(this.storeInfo.plastic_unit, 10) : null,
          plastic_option: this.plasticSelect,
          delivery_need_plastic: this.deliveryNeedSelect,
          is_plastic_amount_adjustable: this.plasticAmountAdjustable
        }

        // 塑膠袋預設勾選
        var dWayPlastic = []
        if (this.deliveryWayPlastic) {
          this.deliveryWayPlastic.forEach(function (delivery) {
            if (delivery.value) {
              dWayPlastic.push(delivery.value)
            }
          })
          data['delivery_way_plastic_selected'] = dWayPlastic
        }
      } else if (method === 10) {
        data = {
          printer_layout_setting: []
        }
        this.printerLayoutSetting.forEach(function (layoutSetting) {
          const obj = {
            layout_type: layoutSetting.layout_type,
            trigger_type: layoutSetting.trigger_type,
            is_enabled: layoutSetting.is_enabled
          }
          data.printer_layout_setting.push(obj)
        })
        data.printer_layout_setting = JSON.stringify(data.printer_layout_setting)
      } else if (method === 12) {
        if (this.checkCommission()) {
          this.$notify({
            title: '提醒',
            text: this.checkCommission(),
            duration: 3000,
            type: 'danger',
            width: 400
          })
          return false
        }
        const query = this.setCommissionQuery()
        data['order_commission_setting'] = JSON.stringify(query)
      } else if (method === 13) {
        let arr = this.storeInfo.store_shipping_vendor.filter(item => {
          return item.is_enable !== null
        })
        if (arr.length) {
          data['store_shipping_vendor'] = JSON.stringify(arr)
        }

      // 特殊需求
      } else if (method === 15) {
        data = {
          store_special_item_setting: JSON.stringify([{
            type: 1,
            sub_type: 1,
            is_show: this.showTablewareStrawOption,
            default_value: this.setTablewareStrawDefaultVal
          }])
        }
      }
      const sendData = this.setData(data)
      data = {
        ...sendData,
        store_list: this.includeStoresSetting.choose.toString()
      }
      if (this.removeComment) data.comment = ''
      if (isChecked) {
        data.is_checked = 1
      }
      var url = '/brand/' + this.$route.params.brand_id + '/syncStore/create'
      this.getDataH('POST', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
        }
      }, (error) => {
        if (error.response && error.response.data && error.response.data.invalid_params_store_map) {
          this.invalidStoreMap = error.response.data.invalid_params_store_map
          let button = document.getElementById('reCheckButton')
          if (button) {
            button.click()
          }
        } else {
          return null
        }
      })
    },
    setData (data) {
      let sendData = {}
      Object.keys(data).forEach((key) => {
        if (data[key] !== null) {
          sendData[key] = data[key]
        }
      })
      return sendData
    },
    intranceName (type) {
      switch (type) {
        case 1:
          return '你訂平台'
        case 2:
          return '專屬網址'
        case 3:
          return 'LINE'
      }
    },
    goToStoreTable () {
      this.$router.push('/storeTable/' + this.$route.params.brand_id)
    },
    getPrinterStoreList () {
      var self = this
      var url = '/printer/storePrinterList/' + this.$route.params.store_id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.printerStoreList = response.data.list
          self.getPrinterList()
        }
      })
    },
    getPrinterList () {
      var self = this
      var data = {
        page: 1,
        size: 20
      }
      var url = '/printer/list?page=' + data.page + '&size=' + data.size
      if (this.searchResult) url = url + '&identity=' + this.searchResult
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.printerList = response.data.list
          if (self.printerList.length) self.isPrinterSelect = self.printerList[0].printer_id
          self.printerInfo = {
            identity: '',
            type: 1
          }
        }
      })
    },
    checkPrinter () {
      var msg = ''
      if (!this.printerInfo.identity && this.printerSelect === 1) {
        msg = '請輸入辨識碼'
      }
      this.getToast2(msg)
    },
    getToast2 (msg) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        if (this.printerSelect === 1) this.addPrinter()
        else this.crPrinterStore(this.isPrinterSelect)
      }
    },
    addPrinter () {
      var self = this
      var url = '/printer'
      var info = this.printerInfo
      var data = {
        type: info.type,
        identity: info.identity
      }
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.crPrinterStore(response.data.printer_id)
        }
      })
    },
    crPrinterStore (printerId) {
      var self = this
      var url = '/printer/storePrinter'
      var data = {
        printer_id: printerId,
        store_id: this.$route.params.store_id
      }
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getPrinterStoreList()
        }
      })
    },
    printerType (type) {
      switch (type) {
        case 1: return 'W牌出單機(1)'
        case 2: return 'F牌出單機(2)'
        case 3: return 'F牌貼紙機(3)'
      }
    },
    selectOnChange (value) {
      this.change.binding_is_enabled = value
    },
    inputOnChange (value) {
      this.change.binding_name = value
    },
    trigger (event) {
      if (event === 'delBinding') {
        this.delBinding()
      } else if (event === 'editBinding') {
        this.editBinding()
      } else if (event === 'updateBinding') {
        this.updatedStore()
      } else if (event === 'reCheckBinding') {
        this.updatedStore(true)
      } else if (event === 'reCheckCancel') {
        this.invalidStoreMap = null
      }
    },
    delBinding () {
      var self = this
      var url = '/printer/storePrinter/' + this.current.binding_id
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getPrinterStoreList()
        }
      })
    },
    editBinding () {
      var self = this
      var url = '/printer/storePrinter/' + this.current.binding_id
      var data = {
        is_enabled: this.change.binding_is_enabled
      }
      if (this.current.binding_name) data['name'] = this.change.binding_name
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.change = {
            is_enabled: 1,
            binding_name: ''
          }
          self.getPrinterStoreList()
        }
      })
    },
    getCurrent (obj) {
      this.current = obj
      this.editOption.body = '編輯出單機' + obj.printer_identity + '綁定'
      this.selectChange = obj.binding_is_enabled
      this.change = {
        is_enabled: obj.binding_is_enabled,
        binding_name: obj.binding_name
      }
    },
    clickClose (type, notSupport, val, index) {
      if (type === 'deliveryWays') {
        if (parseInt(val, 10) === 1) {
          this.$refs.pickupWarnModal.click()
          this.$nextTick(() => {
            // 支援與開啟狀態都必須為 1
            this.deliveryWaysInfo[index].is_enable = 1
            this.deliveryWaysInfo[index].is_support = 1
          })
        } else if (notSupport) {
          this.deliveryWaysInfo[index].is_enable = 0
          this.deliveryWaysInfo[index].is_support = 0
        }
      } else if (type === 'tradeType') {
        if (parseInt(val, 10) === 1) {
          this.$nextTick(() => {
            // 支援與開啟狀態都必須為 1
            this.tradeInfo[index].is_enable = 1
            this.tradeInfo[index].is_support = 1
          })
        }
      }
    },
    addExceptionTrade () {
      var obj = {
        delivery_type: 0,
        start_money: '',
        end_money: '',
        trade_type: 1
      }
      this.exceptionTradeList.push(obj)
    },
    exportUrl () {
      // 輸出桌號網址 csv
      if (this.tableNumberUrl.text) {
        const arr = this.tableNumberUrl.text.split(/,|\n|，/) // 依 , (全形與半形)與 \n (換行符號) 切割字串
        const csvFile = [
          ['入口', '桌號', '網址']
        ]
        arr.forEach(number => {
          const numberWithTrim = number.trim() // 去除前後空白
          if (numberWithTrim) {
            let row = []
            this.enterType.forEach(x => {
              if (x.value === this.tableNumberUrl.type) {
                let url = `${x.url}/onSite/${this.$route.params.store_id}/store?tableNo=${numberWithTrim}`
                 // 輸出 => [入口, 桌號, 網址]
                row.push(x.name, numberWithTrim, url)
                csvFile.push(row)
              }
            })
          }
        })
        if (csvFile.length > 1) {
          let data = csvFile.map(e => e.join(',')).join('\n')
          downloadFile(data, '桌號網址.csv', 'text/csv;charset=utf-8', new Uint8Array([0xEF, 0xBB, 0xBF]))
        }
      }
    },
    setCommissionQuery () {
      // 設定計算方式 API 參數
      let query = JSON.parse(JSON.stringify(this.orderCommissionSetting))
      if (!this.orderCommissionSetting.item_list.length) {
        delete query['item_list']
      } else if (this.orderCommissionSetting.type === 1) {
        // 系統費則無門市獨立報表與資訊服務費細項
        delete query['item_list']
        query['has_independent_report'] = 0
      } else {
        // 生效時間加上 00 / 結束時間加上 59
        query.item_list.forEach(item => {
          item.start_time = `${item.start_time}:00`
          item.end_time = `${item.end_time}:59`
        })
      }
      return this.setData(query)
    },
    notBeforeToday (date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0))
    },
    notBeforeTodayAddTwoMins (date) {
      return date < new Date(moment().set('second', 0).add(5, 'm').toString())
    },
    setTakeTime (type = '', item = {}) {
      // 10 的倍數加減
      let timeSeg = 0
      const val = item.take_time_seg
      if (type === 'add') {
        timeSeg = (Math.floor(val / 10) * 10) + 10
      } else if (type === 'minus' && val > 10) {
        timeSeg = (Math.ceil(val / 10) * 10) - 10
      }
      item.take_time_seg = timeSeg
    },
    clickOutsideCloseCalendar (event) {
      // 檢查點擊的地方是否在某日曆 item 上 或 multiselect 內
      const calendarContainers = document.querySelectorAll('.calendar-container')
      calendarContainers.forEach((container, index) => {
        if (!container.contains(event.target)) {
          // 點擊在容器外部，關閉該 item 的日曆
          if (this.selectSpecialDay[index]) {
            this.selectSpecialDay[index].showSpecialDayCalendar = false
          }
        }
      })
      // 檢查公休日期日曆
      const offDayCalendarContainers = document.querySelectorAll('.calendar-container')
      let clickedOutsideOffDayCalendar = true
      offDayCalendarContainers.forEach((container) => {
        if (container.contains(event.target)) {
          clickedOutsideOffDayCalendar = false
        }
      })
      if (clickedOutsideOffDayCalendar) {
        this.showCalendar = false
      }
    }
  },
  created () {
    this.init()
  },
  mounted () {
    if (this.$route.query.tab) {
      this.storeMethod = Number(this.$route.query.tab)
    }

    // 監聽 DOM，只對 class = calendar-multiselect 的 multiselect 移除 multiselect__content-wrapper 欄位
    const observer = new MutationObserver(() => {
      const calendarMultiselects = document.querySelectorAll('.calendar-multiselect')
      calendarMultiselects.forEach(multiselect => {
        // 刪除 calendar-multiselect 的 wrapper
        const wrappers = multiselect.querySelectorAll('.multiselect__content-wrapper')
        wrappers.forEach(wrapper => {
          wrapper.remove()
        })
      })
    })

    // 監聽 document.body 的變化
    observer.observe(document.body, {
      childList: true, // 監聽子元素列表的添加/刪除
      subtree: true // 監聽整個深層的樹形結構（所有層級）元素
    })
    // 監聽點擊事件，關閉日曆
    document.addEventListener('click', this.clickOutsideCloseCalendar)
  },
  beforeDestroy () {
    // 移除點擊事件監聽
    document.removeEventListener('click', this.clickOutsideCloseCalendar)
  },
  components: {
    'img-upload': ImgUploadTemp,
    'date-time-picker': datetimePicker,
    'shipping-form': ShippingForm,
    'm-modal': matcherModal,
    VueTimepicker,
    DatePicker,
    'delivery-limit': DeliveryLimit
  },
  computed: {
    ...mapGetters(['getRoleType', 'getRestricted']),
    // 公休時間不提供「無指定」(value 0)，選到會導致無法儲存
    offdayWeekDayOptions () {
      return this.offdaySetting.options.weekDay.filter(item => item.value)
    },
    offdayMonthDayOptions () {
      return this.offdaySetting.options.monthDay.filter(item => item.value)
    },
    calendarLimits () {
      return {
        min: moment().format('DD/MM/YYYY'),
        max: '31/12/2126'
      }
    },
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    },
    showTableNumber () {
      // 桌邊點餐開啟才顯示桌號設定
      const table = this.deliveryWaysInfo.find(item => {
        return item.take_type === 21
      })
      return table ? Number(table.is_enable) : 0
    },
    shippingInfo () {
      if (!this.deliveryWaysInfo) return {}
      return this.deliveryWaysInfo[2] || {}
    },
    reCheckOption () {
      let body = this.invalidStoreMap ? '<ul style="padding-left: 2rem; margin: 0.5rem 0;">' : ''
      if (this.invalidStoreMap && this.invalidStoreMap.delivery_ways) {
        let deliveryMap = this.deliveryTypeOption.reduce((acc, cur) => {
          acc[cur.value] = cur.label
          return acc
        }, {})

        Object.keys(this.invalidStoreMap.delivery_ways).forEach((key) => {
          let deliveryWay = this.invalidStoreMap.delivery_ways[key]
          if (deliveryWay && deliveryWay.is_enabled) {
            let deliveryType = deliveryMap[key]
            let stores = Object.values(deliveryWay.is_enabled).join('、')
            body += `<li>取餐類型「${deliveryType}」: 於以下門市為預設取餐方式或不支援的狀態<br>無法變更門市：${stores}</li>`
          }
        })
      } else if (this.invalidStoreMap && this.invalidStoreMap.is_invoice_exception) {
        const invoiceExceptionArray = Object.keys(this.invalidStoreMap.is_invoice_exception)
        invoiceExceptionArray.forEach((key) => {
          let stores = this.invalidStoreMap.is_invoice_exception[key]
          body += `<li>於以下門市設定開立發票，需至少開放任一發票類型 (紙本發票、電子載具、愛心捐贈發票)，開放狀態無法變更為停用<br>無法變更門市：${stores}</li>`
        })
      } else if (this.invalidStoreMap && this.invalidStoreMap.trade_types) {
        let tradeTypeMap = this.tradeTypeOption.reduce((acc, cur) => {
          acc[cur.value] = cur.label
          return acc
        }, {})

        Object.keys(this.invalidStoreMap.trade_types).forEach((tradeTypeId) => {
          let tradeTypeStores = this.invalidStoreMap.trade_types[tradeTypeId]
          let storeNames = []

          Object.keys(tradeTypeStores).forEach((storeId) => {
            let storeInfo = tradeTypeStores[storeId]
            if (storeInfo && storeInfo.is_support === '0') {
              storeNames.push(storeInfo.name)
            }
          })

          if (storeNames.length > 0) {
            let tradeTypeLabel = tradeTypeMap[tradeTypeId]
            let storesText = storeNames.join('、')
            body += `<li>付款類型「${tradeTypeLabel}」: 目前尚未於以下門市開通<br>無法變更門市：${storesText}</li>`
          }
        })
      }

      body += this.invalidStoreMap ? '</ul>' : ''
      return {
        id: 'reCheckModal',
        title: '部分設定無法變更',
        body,
        btns: [
          {
            name: '取消',
            event: 'reCheckCancel'
          },
          {
            name: '確定',
            event: 'reCheckBinding'
          }
        ]
      }
    },
    hasInvoiceSelected () {
      return this.hasInvoiceCarrierSelect === 1 || this.hasInvoicePaperSelect === 1 || (this.getRoleType === 99 && this.hasInvoiceNpobnaSelect === 1)
    },
    allInvoiceClosed () {
      return this.hasInvoiceCarrierSelect === 0 && this.hasInvoicePaperSelect === 0 && (this.getRoleType !== 99 || this.hasInvoiceNpobnaSelect === 0)
    }
  },
  watch: {
    form: {
      handler: function () {
        this.getStoreBrief()
      },
      deep: true
    },
    citySelect () {
      var cityCode = parseInt(this.citySelect, 10)
      var cityElement = this.cityAreaList.find(function (e, i, o) {
        return e.city_code === cityCode
      })
      let areaList = cityElement.area_list
      this.areaOption = []
      for (var i = 0; i < areaList.length; i++) {
        var option = {name: areaList[i].name, value: areaList[i].area_code}
        this.areaOption.push(option)
        if (i === 0 && (this.$route.name !== 'upStore' || this.areaTimes)) {
          this.areaSelect = option.value.toString()
        } else this.areaTimes = 1
      }
    },
    'storeInfo.city_code' () {
      if (this.$route.name === 'upStore') this.areaSelect = this.storeInfo.area_code
    },
    imgLogoSelect () {
      var self = this
      if (self.imgLogoSelect) {
        let imgSrc = this.imgLogoOption.find(function (e) {
          return e.name === self.imgLogoSelect
        }).value
        this.storeInfo.image_name = imgSrc
      }
    },
    imgBgSelect () {
      var self = this
      if (self.imgBgSelect) {
        let imgSrc = this.imgBgOption.find(function (e) {
          return e.name === self.imgBgSelect
        }).value
        this.storeInfo.bg_image_name = imgSrc
      }
    },
    'tableNumber.sub_delivery_type' (val) {
      if (val === 1) {
        this.tableNumber.is_table_no_required = 0
        this.tableNumber.show_table_no = 0
      }
    },
    storeMethod (val) {
      const tab = {
        tab: val
      }
      this.$router.push({query: tab})
      this.invalidStoreMap = null
    },
    /**
     * 外送金額
     * 第一段「滿{A}元即可外送」，需要與新增的第二段「滿{B}元可外送 {C}公尺以內」，{A}的直需要同步連動更改於{B}
     */
    deliveryWaysInfo: {
      deep: true,
      handler (val) {
        if (typeof this.deliveryOther[0] !== 'undefined' && this.deliveryOther[0] !== null) {
          this.deliveryOther[0].price = val[2].price
        }
      }
    },
    hasInvoiceSelected (val) {
      if (val) {
        this.isInvoiceException = 0
      }
    },
    allInvoiceClosed (val) {
      if (val) {
        this.isInvoiceException = 1
      }
    }
  }
}
</script>
<style lang="sass" scoped>
.border
  border: 1px solid #d2d6de;
  padding: 8px;
.pa-30
  padding: 30px
.form-box
  margin: 10px;
  background-color: #FFF;
.btn-close
  line-height: 1.1
.mr-10
  margin-right: 10px
.mt-10
  margin-top: 10px
.ml-10
  margin-left: 10px
.pb-10
  padding-bottom: 10px
.pa-20
  padding: 20px
.pt-5
  padding-top: 5px
.p-a-0
  padding: 0px
.pa-20
  padding: 20px
.px-20
  padding: 20px 0
.border-bottom
  border-bottom:  1px solid #e5e5e5
.radio input:disabled
  opacity: 0.5
.radio-text--disabled
  opacity: 0.5
.radio+.radio
  margin-top: initial
.hint
  position: relative
.re-check-close
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
  color: #3C8DBC;
  z-index: 9;
.text-align-left
  text-align: left !important;
.calendar-container
  position: relative;
  width: 100%;
  min-width: 150px;
.calendar
  position: absolute;
  z-index: 1001;
  max-width: 290px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
.calenderClose
  position: absolute;
  z-index: 1000;
  top: 300px;
  left: 186px;
.specialDayCalendarTable-responsive
  min-height: 450px;
  overflow-y: auto;
.sticky-header
  position: sticky;
  top: 0;
  z-index: 10;
.date-picker-cell
  width: 500px;
  vertical-align: top;
.remark-cell
  width: 300px;
  min-width: 300px;
  vertical-align: top;
.multiselect
  white-space: normal !important;
  word-wrap: break-word !important;
  min-height: 38px;
  width: 100%;

@media (max-width: 768px)
  .calendar-container
    max-width: 100%;
    width: 100%;
  .date-picker-cell
    width: auto;
    max-width: 100%;
  .remark-cell
    width: auto;
    min-width: 200px;
</style>



// WEBPACK FOOTER //
// BatchSetupStore.vue?bb3af250